const CONSTANTS = require('../../lib/constants');
const utils = require('../../lib/utils')
const moment = require('moment'); // TODO: why not utils.moment?

module.exports = {
	parentForm: undefined,

	config: {
		resourceUrl: '',
		creationMode: true,
		copyMode: false,
		submitAllResources: false,
		autoSubmitOnChange: false,
		dirtyModelPersistent: false,
		forceDirty: false, // @see setDirty() and setClean() methods for details
		forceNonDirtyValidation: false, // on submit validation will be skipped if there are no dirty values. this may be necessary in some cases for strictly mandatory fields.
		componentDataDependentFieldAssociation: false,
		deactivateFormComponentDataFields: false,
		preventModelFieldsBeingRendered: false,
		parentFormResourceKey: 'children',
		isRelationshipChild: false,
		relationshipDataIndex: -1,
		isEmptyForm: false,
		checkForBrowserFills: false,
		resetDirtyFieldsAfterSuccessfulSubmit: true,
		resetDirtyFieldsBeforeRefresh: false, // defines if this form should reset all its dirties just in case it will be refreshed. this may come in handy if the resourceData loaded via refresh should override the actual dirtyFields set within this form.
		contextClass: '',
		resourceConnected: true,
		isStaticForm: false,
		setDefaultValuesAfterResourceSanitize: false,
		fieldTypes: {
			'category-picker':  { defaultSource: 'picker' },
			'resource-picker':  { defaultSource: 'picker' },
			'tag-picker':  		{ defaultSource: 'none' },
			'template-picker':  { defaultSource: 'config' },
			'route-picker':     { defaultSource: 'config' },
			'select':           { defaultSource: 'config' },
			'html':             { defaultSource: 'config' },
			'text':             { defaultSource: 'config' },
			'boolean':          { defaultSource: 'config' },
			'integer':          { defaultSource: 'config' },
			'float':            { defaultSource: 'config' },
			'time':             { defaultSource: 'config' },
			'datetime':         { defaultSource: 'config' },
			'date':             { defaultSource: 'config' },
			'json':             { defaultSource: 'config' }
		},
		focusAble: true,
		focusPriority: 500,
		onSubmitDonePanelMessage: 'status.done.save',
		validationErrorHandling: {
			strategy: 'inline'
		},
		simpleSubForm: false,
		preventAllFieldLabels: false,
		preventKeyDownControls: false,
		autoSubmitOnAttach: false,
		onSubmitDoneHandlerOptions: {},
		isProtocolActionForm: false,

		prepareFieldsAutomatically: false, // this flag is set according to the absence of a formMapping. this has not to be configured it will be overwritten by the form's lifecycle anyway.
		isFieldCodeSelector: false, // fieldCode-selectors are forms instanced by the same rules as a usual form, but are used to select exactly these templateAtoms by fieldCode via toggle.
		preventFieldCodeSelectorFields: false, // a fieldCode-selector usually depicts a disabled variant of the form field besides the toggle. if the label is just enough one may set this flag to true.
		submitEventDefaultsGranted: false, // usually a submit event
	},

	model: {
		dirtyFields: {},
		resourceAttributeMapping: {},
		fieldProperties: {},
		globalStaticFields: {},
		preventSubmit: false,
		visibilityByFieldCode: {},
		// MARK: FORM_PREVENT_DIRTIES
		// in some cases a form has to prevent to accept dirty changes.
		// e.g., 	someone changes a text-field-value and presses escape to reset the form.
		// 			the form refreshes,
		// 			the text-field receives a change-event due to the lost focus and sets the new dirty value via fieldToModel,
		// 			the text-field will be included by the inclusion action afterwards and shows the new dirty field
		// 			although the user wanted to reset the form to non-dirty values.
		preventDirties: false,
	},

	events: {
		/**
		 * this event will be fired any time a click will be performed.
		 * so it is possible to control the click-behaviour within this event-handler without the necessity of registering an event-handler for each button.
		 *
		 * @param event
		 */
		click: function(event){
			const self = event.data.component
			var target = event.originalEvent ? event.originalEvent.target : event.target;
			var $target = $(target)
			var $field = $target.next()
			var labelClicked = $target.hasClass('base_form_elements_label')
			var fieldAvailable = $field.length > 0

			// handle click on labels and focus input element if possible
			if (labelClicked && (self.config.isFieldCodeSelector || fieldAvailable)){
				event.stopImmediatePropagation();

				if(self.config.isFieldCodeSelector){
					const $toggle = $target.closest('.fieldCodeSelector').find('.control > .base_form_fields_toggle')
					if($toggle.length > 0) $toggle.click();
				}
				else if(fieldAvailable){
					if($field.is('input, textarea, select')){
						$field.focus();
					} else if($field.is('.base_form_fields_checkbox')) {
						$field = $field.find('input[type="checkbox"]');
						//$field.prop('checked', !$field.prop('checked'));
						// wt: fix; a click-event must be fired to provide functionality if a click event is bound to the checkbox; otherwise it is only checked but no event is fired
						$field.click();
					} else {
						$field.click();
					}
				}

				return;
			}

			var type;
			if((type = target.nodeName.toLowerCase()) != 'button' && ($target = $target.parentsUntil('form', 'button')).length == 1){
				target  = $target[0];
				type    = target.nodeName.toLowerCase();
			}
			var fieldType = target.dataset.fieldType;

			switch(type){
				case 'button':
					switch(fieldType){
						case 'save':
						case 'submit':
							// subforms does not perform any submits
							if(!!self.parentForm) return;

							// prevent non connected parent forms from being reset
							if(!self.config.submitEventDefaultsGranted) {
								event.preventDefault()
							}
							event.stopImmediatePropagation()

							self.submit();
							break;

						case 'cancel':
							// subforms does not perform any cancellations
							if(!!self.parentForm) return;

							// prevent non connected parent forms from being reset
							event.preventDefault();
							event.stopImmediatePropagation();

							// reset dirty fields
							self.model.dirtyFields = {};
							// sanitize resources of all subForms
							self.forEachSubForm(function(subFormComponent){
								subFormComponent.model.dirtyFields = {};
							});

							// clear dom representation of this form
							if(self.config.preventClearOnCancel) {
								// no dirties until refresh is done.
								self.model.preventDirties = true
								self.refresh(undefined, undefined, undefined, undefined, undefined, undefined, undefined, () => {
									self.model.preventDirties = false
								});
							} else {
								self.clear();
							}
							// call on cancel
							self.onCancel();
							// call after cancel handler
							self.callHandler('afterCancel');
							break;

						default:
							// subforms have to try to handle the actions themselves before handing over the responsibility if necessary.
							if(!!self.parentForm) {
								return utils.performButtonAction(event, undefined, { sourceComponent: self }, undefined, true).then(resolveData => {
									if((resolveData || {}).actionPerformed){
										// prevent buttonActionHandling by parentForm if this action has been handled by this relationshipForm
										event.preventDefault();
										event.stopImmediatePropagation();
									}
								});
							} else {
								utils.performButtonAction(event);
							}

							// TODO: onAction handler?
							// utils.performButtonAction(event).then(function(context){
							// 	self.callHandler('onAction', [context.response, context.fieldType, context.buttonContext, context.buttonMode]);
							// });
							break;
					}
					break;
			}
		},

		/**
		 * this event handler is used to move all simple fields' values into the form model and set the dirty flag if necessary.
		 * all complex fields (field components) has to prevent the change event propagation of their simple fields and have to call the fieldToModel method of their parent form.
		 *
		 * @param event
		 */
		change: {
			type: 'change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				var target = event.originalEvent ? event.originalEvent.target : event.target;
				var fieldCode = target.dataset.fieldCode;
				var fieldType = target.dataset.fieldType;

				var value = utils.dom.getHtmlFieldValue(fieldType, target);

				// set model values according to the given fieldCode and its value
				if(fieldCode !== undefined){
					event.data.component.fieldToModel(fieldCode, value);
				}
			}
		},

		changeBootstrapDateTimePicker: {
			type: 'dp.change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				var target = $(event.target).find('input')[0];
				var fieldCode = target.dataset.fieldCode;
				var fieldType = target.dataset.fieldType;

				var value;
				if(event.date && event.date._d){
					value = event.date._d.toISOString();
				}
				else {
					value = utils.dom.getHtmlFieldValue(fieldType, target);
				}

				// set model values according to the given fieldCode and its value
				event.data.component.fieldToModel(fieldCode, value);
			}
		},

		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target);
				var keyCode = utils.keyboard.getKeyCode(event);
				if(self.config.preventKeyDownControls && (keyCode === 'enter' ||  keyCode === 'esc')) {
					event.stopImmediatePropagation();
					event.stopPropagation();
					event.preventDefault();

					// change value only
					if($target.closest('button, textarea').length <= 0 && keyCode === 'enter'){
						$target.blur();
					}
				}
				else if($target.closest('button, textarea').length > 0 && keyCode === 'enter') {
					event.stopImmediatePropagation();
				}
				else {
					var positive = false;
					switch(keyCode){
						case 'enter':
							positive = true;
							// be sure that the original element looses the focus to trigger change events if necessary
							$(event.target).blur();
						case 'esc':
							var $useButton;
							event.preventDefault();
							if(positive){
								if(($useButton = event.data.component.$.find('.buttons button.positive:visible')).length == 1){
									event.stopImmediatePropagation();
									$useButton.click();
								}
								else if(($useButton = event.data.component.$.find('.buttons button:not(.positive):not(.negative):visible')).length == 1){
									event.stopImmediatePropagation();
									$useButton.click();
								}
							}
							else {
								if(($useButton = event.data.component.$.find('.buttons button.negative:visible')).length == 1){
									event.stopImmediatePropagation();
									$useButton.click();
								}
							}
							break;
					}
				}
			}
		},

		/**
		 * prevent forms' default behaviour
		 *
		 * @param event
		 */
		submit: function(event){
			event.preventDefault();
		},

		showFieldDescription: {
			type: 'mouseenter',
			selector: '.base_form_elements_field',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				var self = event.data.component;
				var $target = $(event.target).closest('.base_form_elements_field');
				if($target.length > 0){
					var $field = $target.find('[data-field-code]');
					if($field.length > 0){
						var fieldCode = $field.data('fieldCode');
						var field = self.model.namedFields[fieldCode || 'NON_EXISTING_FIELD'];
						if(field){
							var info = (((field || {}).lang || {})[self.model.langCode || 'de-at'] || {}).info || '';
							if(info) {
								self.showFieldDescription(info);
							}
						}
					}
				}
			}
		},
		showFieldDescriptionByFocus: {
			type: 'focus',
			selector: '.base_form_elements_field input, .base_form_elements_field button, .base_form_elements_field select, .base_form_elements_field textarea',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('.base_form_elements_field');
				if($target.length > 0){
					var $field = $target.find('[data-field-code]');
					if($field.length > 0){
						var fieldCode = $field.data('fieldCode');
						var field = self.model.namedFields[fieldCode || 'NON_EXISTING_FIELD'];
						if(field){
							var info = (((field || {}).lang || {})[self.model.langCode || 'de-at'] || {}).info || '';
							if(info) {
								self.showFieldDescription(info);
							}
						}
					}
				}
			}
		},

		hideFieldDescription: {
			type: 'mouseleave',
			selector: '.base_form_elements_field',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.hideFieldDescription();
			}
		},
		hideFieldDescriptionByFocus: {
			type: 'blur',
			selector: '.base_form_elements_field input, .base_form_elements_field button, .base_form_elements_field select, .base_form_elements_field textarea',
			action: function(event){
				event.data.component.hideFieldDescription();
			}
		},
	},

	methods: {

		/**
		 * this function defines some default actions needed by every form.
		 * it will be called when the resourceUrl can contain a valid value and before any attach triggers.
		 */
		prepareDefaultActions: function(){
			if(this.config.resourceConnected){

				// the forms resourceUrl would normally be prepared within the client during the action-perform-process.
				// however, there are some special cases where this can't be done such like:
				// 		if the form is rendered on the server, has a resource but cannot load it (e.g., create new record form like event.registrationForm-preAuth)
				// 		in this case no action-perform-process has been started yet and the server had no chance to be sure that the time is right to prepare a resourceUrl.
				// 		e.g., the form might have a resourceRegister dependency, which may lead to a primaryKey presence, which would lead to a PATCH instead of a POST and the primaryKey would be present within the last part of the resourceUrl.
				// since forms get assigned their resource definitions via refreshResources-standard-action, and this is the last possible time a resourceUrl may be prepared the form can try to do exactly that.
				let isSubForm = false
				if(!this.config.resourceUrl){
					// if this form a subForm of another one it will never need a resourceUrl.
					this.parentComponents('base_form_form', form => {
						isSubForm = true
						return false
					})

					// if the refreshResources-action has been prepared the form has a chance to get it's resourceUrl
					if(!isSubForm && this.actions.refreshResources){
						const action = this.actions.refreshResources
						const actionSource = (action.source || {}).load || {}
						const foundResourceUrl = actionSource.resourceUrl

						// maybe the resourceUrl has been prepared within the refreshResources-action already.
						if(foundResourceUrl){
							this.config.resourceUrl = foundResourceUrl
						}
						// if the refreshResources-action has been prepared properly without a resourceUrl the form can go on.
						// NOTE: if so the resourceConfig should be a resourceHash usable within the url.
						else if (actionSource.resourceConfig && typeof actionSource.resourceConfig === 'string') {
							// gather resourceRegisterContent if possible to give this process a change of recognizing primaryKey dependent PATCHes.
							let resourceRegisterContent = {}
							if(this.config.resourceRegisterKey){
								resourceRegisterContent = this.getResourceRegisterContent(this.config.resourceRegisterKey)
							}

							this.config.resourceUrl = actionSource.resourceUrl = this.getResourceUrl(actionSource.resourceConfig, {
								component: this,
								action,
							}, 'load', resourceRegisterContent)
						}
					}
				}

				// if despite all attempts to gather a resourceUrl no candidate has been found form-submits and associated followup-errors will be prevented.
				if(!this.config.resourceUrl && !isSubForm){
					this.config.resourceConnected = false
					// NOTE: 	resourceConnected === false does not interfere with field-actions, field-resources or resourceRegister-processes.
					// 			this flag is used for purposes concerning the managed form-data only.
					console.error(`form @ [${this.componentIndex}: ${this.componentClass}] has no resourceUrl which may be normal as well as a problem. please consider "config.resourceConnected = false" for components without any resources management capabilities like filter-forms or treeManagement-action-forms etc. to prevent some needless stuff as well as this message.`)
					return
				}

				// define default submit action if necessary
				this.actions.submit = {
					type: CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE,
					source: {
						submit: {
							resourceUrl: this.config.resourceUrl,
							headers: {
								fec_method: this.config.creationMode || this.config.copyMode ? 'POST' : 'PATCH'
							},
							httpMethod: this.config.creationMode || this.config.copyMode ? 'POST' : 'PATCH'
						}
					},
					statusControllerLoadingMessage: this.config.statusControllerLoadingMessage,
					statusControllerSavingMessage:  this.config.statusControllerSavingMessage
				};
			}
		},

		/**
		 * create resourceAttributeMapping between template- and resource-fieldCodes,
		 * prepare modelFieldIndex for all fields within formMapping and
		 * extend formMapping according to the given model.fields.
		 */
		sanitizeForm: function(storage){
			// init
			var self = this;
			self.model.resourceAttributeMapping = {};
			self.config.preventModelFieldsBeingRendered = self.config.deactivateFormComponentDataFields && self.config.componentDataDependentFieldAssociation && !self.config.isFieldCodeSelector;
			self.config.prepareFieldsAutomatically = utils.isEmpty(this.formMapping);

			// set defaultFormName
			self.config.defaultFormName = 'mainForm';
			if(self.config.subFormAlias || self.config.isRelationshipChild || self.config.simpleSubForm){
				self.config.defaultFormName = 'subForm';
			}

			// extend formMapping by resource dependent dynamic fields of this component's resourceData
			utils.mapAllWithParents(this.formMapping, function(element, key, parent, parentKey){
				// transform short element syntax
				if(parentKey === 'content' && typeof element === 'string'){
					// TODO: fancy static fields format: district:text[hidden]
					// const elementFormat = element.match(/^\s*([^:\[\]\s]*)\s*(:([^:\[\]\s]+))?(\[([^:\[\]\s]+)?\])?\s*$/)
					// if(elementFormat !== null){
					// 	const fieldCode = elementFormat[1]
					// 	const renderType = elementFormat[3]
					// 	const additionalClasses = String(elementFormat[5]).split(',')
					// 	element = {
					// 		type: 'field',
					// 		fieldCode,
					// 		renderType,
					// 		fieldConfig: {
					// 			additionalClasses
					// 		}
					// 	}
					// } else {
						element = {
							type: 'field',
							fieldCode: {
								tpl: element,
								db: element
							}
						}
					// }
				}

				if(utils.isCollection(element)){
					// form field-filter according to formMapping...element.privilegeCode or formMapping...element.roleOption (e.g., cms:component:usage:admin for simplicity)
					if(element.privilegeCode && !self.hasAccessTo(element.privilegeCode, self.scope || undefined)){
						return undefined;
					}
					if(element.roleOption && !self.hasRoleOption(element.roleOption, self.scope || undefined)){
						return undefined;
					}

					// transform short field syntax
					if(parentKey === 'content' && !element.type){
						element.type = 'field'
					}

					if(element.type){
						if(element.type === 'fieldGroup' && (element.source === 'resourceFields' || element.source === 'hiddenResourceFields')){
							element.fields = [];
							// disable form-components fieldgroups if necessary
							if(self.config.deactivateFormComponentDataFields && self.config.componentDataDependentFieldAssociation){
								element.fieldConfig = utils.simpleMerge(element.fieldConfig || {}, { disabled: true });
							}

							utils.forEach(self.model.fields || [], function(field, fieldIndex){
								var fieldConfig = utils.simpleMerge(field.fieldConfig || {}, element.fieldConfig || {});

								// form field-filter according to field.config.privilegeCode or field.config.roleOption (e.g., cms:component:usage:admin for simplicity)
								if(!(
									(fieldConfig.privilegeCode && !self.hasAccessTo(fieldConfig.privilegeCode, self.scope || undefined))
									||
									(fieldConfig.roleOption && !self.hasRoleOption(fieldConfig.roleOption, self.scope || undefined))
									||
									(element.source === 'hiddenResourceFields' && (field.atom || {}).renderType !== 'none')
								)){
									element.fields.push({
										type: 'field',
										modelFieldIndex: fieldIndex,
										fieldCode: {
											db: field.fieldCode,
											tpl: field.fieldCode
										},
										// inherit fieldConfig for all fields within a fieldGroup
										fieldConfig
									});

									// set field mapping of dynamic formMapping fields
									self.model.resourceAttributeMapping[field.fieldCode] = field.fieldCode;
								}
							});
						}
						else if(element.type === 'field'){
							// disable form-components fields if necessary
							if(self.config.deactivateFormComponentDataFields && self.config.componentDataDependentFieldAssociation){
								element.fieldConfig = utils.simpleMerge(element.fieldConfig || {}, { disabled: true });
							}

							// transform short fieldCode syntax
							if(typeof element.fieldCode === 'string'){
								element.fieldCode = {
									tpl: element.fieldCode,
									db: element.fieldCode
								}
							}
						}

						// set field mapping of static formMapping fields
						if(utils.isCollection(element.fieldCode) && element.fieldCode.tpl){
							element.modelFieldIndex = self.getModelFieldIndex(element.fieldCode.tpl);
							if(element.fieldCode.db) self.model.resourceAttributeMapping[element.fieldCode.tpl] = element.fieldCode.db;
						}
					}
				}

				return element;
			});

			// extend field properties by modelFieldIndex and dataType
			var fieldProperties = {};
			var fieldCodes = false;
			self.model.namedFields = {};
			utils.forEach(self.model.fields || [], function(field, fieldIndex){
				// define fieldProperties
				fieldProperties = {
					modelFieldIndex:    		fieldIndex,
					dataType: 					field.atom.dataType,
					renderType: 				field.atom.renderType,
					hasFieldCodeDependency: 	false,
					fieldCodeDependencyList: 	{},
					fieldCode: 					field.fieldCode,

					// the following fields are listed as comments because otherwise there would be no appropriate place to document them.
					// key: 						field.fieldCode, // sometimes a fieldCode is not a valid key but has to be stored anyway. e.g., event-participant-table additional fields defined by the cms of the actual project may contain templateAtoms carrying the same name as a field within the main table.
					// preventRender: 				false, // should the field be rendered? => usually it should be
					// preventValidation: 			false, // should the field be validated? => usually it should be
					// preventTransfer: 			true, // should the field be transmitted to the server if dirtyFields are submitted? => usually it should be
				};

				// config.isFieldCodeSelector is a special variant of rendering a form and all its fields disabled alongside a toggle to select fieldCodes.
				if(self.config.isFieldCodeSelector){
					fieldProperties.dataType = 'boolean'

					// extend fieldProperties by writeSimpleParentJsonAttribute flag
					if(field.config && field.config.parentJSONFieldCode){
						fieldProperties.parentJSONFieldCode = field.config.parentJSONFieldCode
						fieldProperties.originalFieldCode = String(field.fieldCode)
						fieldProperties.fieldCode = field.fieldCode = self.model.fields[fieldIndex].fieldCode = `${fieldProperties.parentJSONFieldCode}_${field.fieldCode}`

						// prepare resourceAttributeMapping according to new fieldCode for fieldCodeSelector-forms regardless of formMapping
						self.model.resourceAttributeMapping[field.fieldCode] = field.fieldCode;
					}
				} else {

					// extend fieldProperties
					if(self.config.componentDataDependentFieldAssociation){
						// extend staticFields
						fieldProperties.staticFields = {
							templateAtomID: field.templateAtomID
						};
					}

					// extend fieldProperties of relation fields
					if(field.config && field.config.relationConfig){
						fieldProperties.relationConfig = field.config.relationConfig;
					}

					// extend fieldProperties by preferEmptyValuePresence flag
					if(field.config && field.config.preferEmptyValuePresence){
						fieldProperties.preferEmptyValuePresence = true;
					}

					// extend fieldProperties by preventTransfer flag
					if(field.config && field.config.preventTransfer){
						fieldProperties.preventTransfer = true;
					}

					// extend fieldProperties by writeSimpleParentJsonAttribute flag
					if(field.config && field.config.writeSimpleParentJsonAttribute){
						fieldProperties.hasFieldCodeDependency = true;
						fieldProperties.writeSimpleParentJsonAttribute = true;
					}

					// prepare resourceAttributes automatically if necessary
					if(self.config.prepareFieldsAutomatically){
						self.model.resourceAttributeMapping[field.fieldCode] = field.fieldCode;
					}

					// extend fieldProperties by separated fieldCodes (fieldCodeDependency)
					if(utils.collectionSize((fieldCodes = ((field.config || {}).separatedFieldCodes))) > 0){
						fieldProperties.hasFieldCodeDependency = true;
						fieldProperties.fieldCodeDependencyList = fieldCodes;
					}

					// remember if this field has to be informed if additional attributes are changed
					if(utils.collectionSize((fieldCodes = ((field.config || {}).handleAdditionalAttributes))) > 0){
						fieldProperties.hasAdditionalAttributes = true;
						fieldProperties.handleAdditionalAttributes = fieldCodes;
					}
				}

				// set fieldProperties
				self.setFieldProperties(field.fieldCode, fieldProperties);

				// set named field reference
				self.model.namedFields[field.fieldCode] = self.model.fields[fieldIndex];
			});

			// add additional fields
			utils.forEach(self.model.fields || [], function(field, fieldIndex){
				// grant access to tag-picker-button-connection-type
				if((field.atom || {}).renderType === 'tag-picker-button' && (field.config || {}).tagConnectionChoosable){

					var newField = {
						atom: {
							code: 'TEXT_LINE',
							dataType: 'text',
							renderType: 'text'
						},
						config: {
							isInvisible: true
						},
						fieldCode: field.fieldCode + '_tagConnection',
						hasExternalDataDependency: false
					}

					// define fieldProperties
					fieldProperties = {
						// modelFieldIndex:    		self.model.fields.length,
						dataType:           		'text',
						hasFieldCodeDependency: 	false,
						fieldCodeDependencyList: 	{},
						fieldCode: 					newField.fieldCode
					};

					// prepare resourceAttributes automatically
					self.model.resourceAttributeMapping[newField.fieldCode] = newField.fieldCode;

					// set fieldProperties
					self.setFieldProperties(newField.fieldCode, fieldProperties);
				}
			})

			// prepare fieldProperties according to fieldCode dependencies
			self.sanitizeFieldCodeDependencyFieldProperties()

			// sanitize data indexes in case of multiple rows within one non-relationship dataSet
			self.sanitizeDataIndexes()

			// potential custom method for inheritance
			self.onSanitizeFormDone(storage)
		},

		/**
		 * this function will be called during a componentTree.build process or directly after performing a LOAD_RESOURCE - Action.
		 * it is used to prepare some lists and change the structure of the resources before it can be handled by this component.
		 */
		sanitizeResources: function(storage){
			// init
			var self = this;

			// define creation mode flag which defines if this form is used to insert or to update something on the client
			self.config.creationMode = utils.isEmpty(self.resourceData) || utils.isEmpty(self.resourceData.data);
			self.config.copyMode = !self.config.creationMode && self.resourceData.data.mode === 'copy';

			if(!self.model.langCode){
				self.model.langCode = storage.langCode || 'de-at'
			}

			// estimate parentForm in case of this being a subForm
			if(!!self.config.subFormAlias && !self.parentForm && storage.isClient){
				self.parentComponents('base_form_form', function(parentForm){
					self.parentForm = parentForm
					self.config.isRelationshipChild = self.parentForm.hasClass('base_form_relationship')
					self.config.isProtocolActionForm = self.parentForm.config.isProtocolActionForm
					return false;
				});
			}

			// sanitize protocolActionForm fields
			if(self.config.isProtocolActionForm){
				if((self.resourceData || {}).protocolAction){
					self.model.protocolActionData = (self.resourceData.protocolAction || {}).data || {}
				} else if (((self.parentForm || {}).model || {}).protocolActionData){
					self.model.protocolActionData = self.parentForm.model.protocolActionData || {}
				}

				if(self.model.protocolActionData){
					self.model.visibilityByFieldCode = utils.getProtocolActionFieldVisibility((self.model.protocolActionData.attributes || {}).fields || {}, self.model.fields, self.config.componentDataDependentFieldAssociation)

					utils.forEach(self.model.fields, function(field, fieldIndex) {
						self.model.fields[fieldIndex].visibilityByFieldCode = self.model.visibilityByFieldCode
						if(field.fieldCode && !self.model.visibilityByFieldCode[field.fieldCode] && self.model.fields[fieldIndex].atom){
							self.model.fields[fieldIndex].atom.renderType = 'none'
						}
					})
				}
			}


			// sub-forms are not focusable
			self.config.focusAble = !self.parentForm;

			// load data from parentForm if necessary
			if(self.parentForm && !self.config.isEmptyForm){
				// inherit dirty fields from parent form if necessary
				if(self.parentForm.model.dirtyFields && self.parentForm.model.dirtyFields.data && self.parentForm.model.dirtyFields.data[self.config.parentFormResourceKey] && self.parentForm.model.dirtyFields.data[self.config.parentFormResourceKey][self.config.subFormAlias]){
					self.model.dirtyFields = self.parentForm.model.dirtyFields.data[self.config.parentFormResourceKey][self.config.subFormAlias];
				}

				// inherit creationMode from parentForm
				self.config.creationMode    = self.parentForm.config.creationMode;
				self.config.copyMode        = self.parentForm.config.copyMode;

				// set resourceData according to parentForm's resourceData
				if(!self.config.creationMode || self.config.copyMode){
					if(self.config.isRelationshipChild) {
						// update relationshipDataIndex if necessary
						if(self.config.separatorKey !== undefined && utils.isFunction(self.parentForm.getRelationshipDataIndex)){
							self.config.relationshipDataIndex = self.parentForm.getRelationshipDataIndex(self.config.separatorKey);
						}

						if((self.parentForm.config.availableSeparators || {}).type === 'single'){
							self.resourceData = {
								data: {
									attributes: (self.parentForm.resourceData.data || {}).attributes || {}
								}
							}
						} else if(self.config.relationshipDataIndex !== undefined && self.parentForm.resourceData.data[self.config.relationshipDataIndex]){
							self.resourceData = {
								data: self.parentForm.resourceData.data[self.config.relationshipDataIndex]
							};
						}
					}
					else {
						if ((self.parentForm.resourceData.data[self.config.parentFormResourceKey] || {})[self.config.subFormAlias] == undefined) {
							self.resourceData = {
								data: {
									attributes: {}
								}
							};
						}
						else if((self.config.availableSeparators || {}).type === 'single'){
							self.resourceData = {
								data: {
									attributes: self.parentForm.resourceData.data[self.config.parentFormResourceKey][self.config.subFormAlias]
								}
							}
						}
						else {
							self.resourceData = self.parentForm.resourceData.data[self.config.parentFormResourceKey][self.config.subFormAlias];
						}
					}
				}
			}

			// sanitize data indexes in case of multiple rows within one non-relationship dataSet
			self.sanitizeDataIndexes();

			// write resource data into model fields
			utils.map(self.model.fields, function(field){
				if(field.fieldCode){
					var fieldProperties = self.getFieldProperties(field.fieldCode);
					var dirtyData, dirtyRelationData, data;
					if(self.model.dirtyFields && self.model.dirtyFields.data) {
						if (fieldProperties.dataIndex !== undefined)    dirtyData = self.model.dirtyFields.data[fieldProperties.dataIndex];
						else                                            dirtyData = self.model.dirtyFields.data;

						if(
							fieldProperties.relationConfig &&
							fieldProperties.relationConfig.subFormAliasContainer &&
							fieldProperties.relationConfig.subFormAlias &&
							dirtyData[fieldProperties.relationConfig.subFormAliasContainer] &&
							dirtyData[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias] &&
							dirtyData[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data
						){
							dirtyRelationData = dirtyData[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data;
						}
					}

					// write dirtyData into model field data attribute if possible
					if(fieldProperties.relationConfig && fieldProperties.relationConfig.assignedPrimaryKey){
						if(
							self.resourceData.data &&
							fieldProperties.relationConfig.subFormAliasContainer &&
							fieldProperties.relationConfig.subFormAlias &&
							self.resourceData.data[fieldProperties.relationConfig.subFormAliasContainer] &&
							self.resourceData.data[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias] &&
							self.resourceData.data[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data
						){
							field[fieldProperties.modelFieldAttributeKey] = self.resourceData.data[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data;
						}
						else {
							field[fieldProperties.modelFieldAttributeKey] = [];
						}

						if(dirtyRelationData){
							var dataIndex, dirtyDataIndex, dataFound;
							data = field[fieldProperties.modelFieldAttributeKey];
							for(dirtyDataIndex in dirtyRelationData){
								dataFound = false;
								for(dataIndex in data){
									if(
										data[dataIndex].attributes &&
										data[dataIndex].attributes[fieldProperties.relationConfig.assignedPrimaryKey] == dirtyRelationData[dirtyDataIndex].attributes[fieldProperties.relationConfig.assignedPrimaryKey]
									){
										dataFound = true;
										utils.refMerge(data[dataIndex], dirtyRelationData[dirtyDataIndex]);
										break;
									}
								}

								if(!dataFound){
									data[dirtyDataIndex] = dirtyRelationData[dirtyDataIndex]
								}
							}
						}
					}
					else if(fieldProperties.writeSimpleParentJsonAttribute && fieldProperties.relatedFieldCode) {
						var relatedFieldProperties = self.getFieldProperties(fieldProperties.relatedFieldCode);
						if(relatedFieldProperties.dataType === 'json' && relatedFieldProperties.attributeKey){
							if(dirtyData && dirtyData.attributes !== undefined && utils.isCollection(dirtyData.attributes[relatedFieldProperties.attributeKey]) && dirtyData.attributes[relatedFieldProperties.attributeKey][fieldProperties.fieldCodeAlias || fieldProperties.fieldCode]) {
								field[fieldProperties.modelFieldAttributeKey] = self.resourceToModelValue(dirtyData.attributes[relatedFieldProperties.attributeKey][fieldProperties.fieldCodeAlias || fieldProperties.fieldCode], fieldProperties);
							}
							else if(!!self.resourceData.data) {
								if(relatedFieldProperties.dataIndex !== undefined)	data = self.resourceData.data[relatedFieldProperties.dataIndex];
								else                                        		data = self.resourceData.data;

								// write resourceData into model field data attribute if necessary
								// NOTE: it is possible that data is undefined in case of missing dataSet row entries (e.g., in case of components_data handling)
								if(data && data.attributes !== undefined && utils.isCollection(data.attributes[relatedFieldProperties.attributeKey]) && data.attributes[relatedFieldProperties.attributeKey][fieldProperties.fieldCodeAlias || fieldProperties.fieldCode]) {
									field[fieldProperties.modelFieldAttributeKey] = self.resourceToModelValue(data.attributes[relatedFieldProperties.attributeKey][fieldProperties.fieldCodeAlias || fieldProperties.fieldCode], fieldProperties);
								}
							}
						}
					}
					else {
						if(dirtyData && dirtyData.attributes !== undefined && dirtyData.attributes[fieldProperties.attributeKey] !== undefined) {
							field[fieldProperties.modelFieldAttributeKey] = self.resourceToModelValue(dirtyData.attributes[fieldProperties.attributeKey], fieldProperties);
						}
						else if(!!self.resourceData.data) {
							if(fieldProperties.dataIndex !== undefined) data = self.resourceData.data[fieldProperties.dataIndex];
							else                                        data = self.resourceData.data;

							// write resourceData into model field data attribute if necessary
							// NOTE: it is possible that data is undefined in case of missing dataSet row entries (e.g., in case of components_data handling)
							if(data && data.attributes !== undefined && data.attributes[fieldProperties.attributeKey] !== undefined) {
								field[fieldProperties.modelFieldAttributeKey] = self.resourceToModelValue(data.attributes[fieldProperties.attributeKey], fieldProperties);
							}
						}
					}
				}

				return field;
			});

			// set special field for dynamic primaryKey to be able to set the primary key in fieldToModel function only
			if(!this.config.creationMode && !this.config.copyMode) {
				if(self.resourceData.data && !Array.isArray(self.resourceData.data) && self.resourceData.data.primaryKey){
					self.model.resourceAttributeMapping['primaryKey'] = self.resourceData.data.primaryKey;
					// TODO: uuids?
					self.setFieldProperties('primaryKey', {
						dataType: 'integer',
						attributeKey: self.resourceData.data.primaryKey
					});
				}
			}
			else if(this.config.setDefaultValuesAfterResourceSanitize || this.config.componentDataDependentFieldAssociation){
				this.setDefaultValues(undefined, true);
			}

			// sanitize resources which are separated into more than one fieldCode
			this.sanitizeResourcesOfSeparatedFieldCodes();

			this.onResourceSanitized(storage)

			if(storage.isServer){
				// prevent parentForm from being sent to the client.
				delete self.parentForm
			}
		},

		/**
		 * this function will be called after sanitizeResources().
		 * since this is the perfect place to manipulate the form's behaviour according to the given resources one may overwrite this skeleton function to do that.
		 *
		 * @param storage		object - actual storage
		 */
		onResourceSanitized: function(storage){
			// NOTE: overwrite as you please
		},

		/**
		 * sanitize resources which are separated into more than one fieldCode
		 */
		sanitizeResourcesOfSeparatedFieldCodes: function(){
			var self = this;
			var combinedData = {};
			var fieldProperties;
			var foreignFieldProperties;
			utils.forEach(self.model.fields, function(field, fieldIndex){
				fieldProperties = self.getFieldProperties(field.fieldCode);
				if(fieldProperties && fieldProperties.hasFieldCodeDependency && utils.collectionSize(fieldProperties.fieldCodeDependencyList) > 0){
					combinedData = {};
					utils.forEach(fieldProperties.fieldCodeDependencyList, function(foreignFieldCode, foreignFieldCodeAlias) {
						foreignFieldProperties = self.getFieldProperties(foreignFieldCode);
						if(foreignFieldProperties){
							if(self.model.fields[foreignFieldProperties.modelFieldIndex]){
								combinedData[foreignFieldCode] = self.model.fields[foreignFieldProperties.modelFieldIndex][foreignFieldProperties.modelFieldAttributeKey];
								combinedData[foreignFieldCodeAlias] = combinedData[foreignFieldCode];
							} else {
								console.warn(`fieldCodeDependency not resolvable: ${foreignFieldCode}`)
							}
						}
					});
					self.model.fields[fieldIndex].dataJSON = combinedData;
				}
			});
		},

		/**
		 * this function will be called during a componentTree.build process if there are no resources.
		 * it is used to prepare the model fields according to the dirty fields if and only if there are no resources to be filled into this form.
		 */
		sanitizeDirtyFields: function(){
			var self = this;

			if(self.model.dirtyFields && self.model.dirtyFields.data) {
				// write dirty fields into model fields
				utils.map(self.model.fields, function(field) {
					if (field.fieldCode) {
						var fieldProperties = self.getFieldProperties(field.fieldCode);
						var dirtyData, dirtyRelationData;
						if (fieldProperties.dataIndex !== undefined)    dirtyData = self.model.dirtyFields.data[fieldProperties.dataIndex];
						else                                            dirtyData = self.model.dirtyFields.data;

						if(
							fieldProperties.relationConfig &&
							fieldProperties.relationConfig.subFormAliasContainer &&
							fieldProperties.relationConfig.subFormAlias &&
							dirtyData[fieldProperties.relationConfig.subFormAliasContainer] &&
							dirtyData[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias] &&
							dirtyData[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data
						){
							dirtyRelationData = dirtyData[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data;
						}

						// write dirtyData into model field data attribute if possible
						if(fieldProperties.relationConfig && fieldProperties.relationConfig.assignedPrimaryKey){
							field[fieldProperties.modelFieldAttributeKey] = [];

							if(dirtyRelationData){
								var dataIndex, dirtyDataIndex, dataFound;
								var data = field[fieldProperties.modelFieldAttributeKey];
								for(dirtyDataIndex in dirtyRelationData){
									dataFound = false;
									for(dataIndex in data){
										if(
											data[dataIndex].attributes &&
											data[dataIndex].attributes[fieldProperties.relationConfig.assignedPrimaryKey] == dirtyRelationData[dirtyDataIndex].attributes[fieldProperties.relationConfig.assignedPrimaryKey]
										){
											dataFound = true;
											utils.refMerge(data[dataIndex], dirtyRelationData[dirtyDataIndex]);
											break;
										}
									}

									if(!dataFound){
										data[dirtyDataIndex] = dirtyRelationData[dirtyDataIndex]
									}
								}
							}
						}
						else if(dirtyData && dirtyData.attributes !== undefined && dirtyData.attributes[fieldProperties.attributeKey] !== undefined) {
							field[fieldProperties.modelFieldAttributeKey] = self.resourceToModelValue(dirtyData.attributes[fieldProperties.attributeKey], fieldProperties);

							// if the actual field is an additional attribute tell dependent field about the change
							if(fieldProperties.isAdditionalAttribute && fieldProperties.relatedFieldCode){
								utils.forEach(self.model.fields, function(relatedField) {
									if(relatedField.fieldCode === fieldProperties.relatedFieldCode){
										relatedField.additionalAttributes[field.fieldCode] = field[fieldProperties.modelFieldAttributeKey]
										return false;
									}
								});
							}
						}
					}

					return field;
				});

				if((this.config.creationMode || this.config.copyMode) && (this.config.setDefaultValuesAfterResourceSanitize || this.config.componentDataDependentFieldAssociation)){
					this.setDefaultValues(undefined, true);
				}
			}
		},

		/**
		 * this function is used to set the data indexes according to multiple rows within one data set.
		 * e.g., componentData
		 */
		sanitizeDataIndexes: function(){
			var self = this;
			// correct data index of all fieldProperties according to fields which has no resourceData given.
			if(self.config.componentDataDependentFieldAssociation && !this.config.isFieldCodeSelector){
				var dataIndex = 0;
				// set dataIndex by resourceData
				if(self.resourceData && self.resourceData.data && Array.isArray(self.resourceData.data) && utils.collectionSize(self.resourceData.data) > 0) {
					// reset previously used data index
					utils.map(self.model.fieldProperties, function(fieldProperties){
						delete fieldProperties.dataIndex;
						return fieldProperties;
					});

					// set resourceData dependent data index within field properties
					var fieldCode;
					utils.forEach(self.resourceData.data, function (componentData, componentDataIndex) {
						// NOTE: componentData may be null in forms containing generic component data fields.
						if(componentData){
							componentDataIndex = parseInt(componentDataIndex);
							if(
								componentData[self.config.parentFormResourceKey] &&
								componentData[self.config.parentFormResourceKey].tplAtomData &&
								componentData[self.config.parentFormResourceKey].tplAtomData.data &&
								componentData[self.config.parentFormResourceKey].tplAtomData.data.attributes
							){
								fieldCode = componentData[self.config.parentFormResourceKey].tplAtomData.data.attributes.fieldCode;
								self.setFieldProperties(fieldCode, {
									dataIndex: componentDataIndex
								});
								dataIndex = componentDataIndex + 1;
							}
							else {
								// identifiy fieldCode according to the given templateAtomID by fieldProperties
								var templateIdentified = false;
								if((componentData.attributes || {}).templateAtomID){
									utils.forEach(self.model.fieldProperties, function(fieldProperties){
										if(((fieldProperties || {}).staticFields || {}).templateAtomID === componentData.attributes.templateAtomID){
											fieldCode = fieldProperties.fieldCode;
											self.setFieldProperties(fieldCode, {
												dataIndex: componentDataIndex
											});
											dataIndex = componentDataIndex + 1;
											templateIdentified = true;
											return false;
										}
									});
								}

								// NOTE:    in case of dynamic forms it is possible that templateAtoms has been added to the component after the creation mode of the form.
								//          in this case the form can save the necessary data but cannot reach the templateAtom definitions.
								//          this flag is a way to prevent problems as a result of this fact.
								if(!templateIdentified) self.resourceData.isDirtyDynamicForm = true;
							}
						}
					});

					// set all other fieldProperties' dataIndex which has not been found within the resourceData
					utils.map(self.model.fieldProperties, function(fieldProperties){
						if(fieldProperties.dataIndex == undefined) fieldProperties.dataIndex = dataIndex++;
						return fieldProperties;
					});
				}
				else {
					// set dataIndex by fieldProperties
					if(utils.collectionSize(self.model.fieldProperties) > 0){
						utils.map(self.model.fieldProperties, function(fieldProperties){
							fieldProperties.dataIndex = dataIndex++;
							return fieldProperties;
						});
					}
					// set dataIndex by model fields
					else if(utils.collectionSize(self.model.fields) > 0){
						utils.forEach(self.model.fields, function(field, fieldIndex){
							self.setFieldProperties(field.fieldCode, { dataIndex: dataIndex++ });
						});
					}
				}
			}
		},

		/**
		 * this function is used to tell the gui what to do with a validationResult.
		 *
		 * @param 	validationResult				{} || true - true if no validationError occurred or list of validationErrors in the following form
		 * 											{
		 * 												<fieldCode>: <errorMessage in user-lang>
		 * 											}
		 * @param 	firstInvalidValidationResult	boolean - is this the first invalid validation result?
		 * 											NOTE: this is needed to estimate if the first invalid field is the first invalid field of all tested forms and subForms.
		 *
		 * @returns boolean has been skipped due to deletion
		 */
		handleValidationResult: function(validationResult, firstInvalidValidationResult){
			// check if validation has to be done at all
			let deletionInCharge = (this.model.dirtyFields.data || {}).type === 'delete'
			if(!deletionInCharge){
				this.parentComponents('base_form_form', form => {
					if((form.model.dirtyFields.data || {}).type === 'delete'){
						deletionInCharge = true
						return false
					}
				})
			}
			if(deletionInCharge) return true;

			let firstError = firstInvalidValidationResult;

			// check which strategy to use
			switch(this.config.validationErrorHandling.strategy){
				case 'inline':
				default:
					// add new errors
					var validationFieldCode, fieldCode, fc, $field, $input;
					for(validationFieldCode in validationResult.fields){
						if(!this.model.fieldProperties || this.model.fieldProperties[validationFieldCode]){
							fieldCode = validationFieldCode;
						}
						else {
							for(fc in this.model.fieldProperties){
								if(this.model.fieldProperties[fc].attributeKey == validationFieldCode){
									fieldCode = fc;
									break;
								}
							}
						}

						if(!fieldCode){
							console.error('validation result does not map the fieldCode structure for fieldCode: ' + validationFieldCode);
						}
						else if(($input = this.$.find('[data-field-code="' + fieldCode + '"]').first()).length > 0){
							// field is valid but tested
							if(validationResult.fields[validationFieldCode] === true){
								$input.removeClass('validationFailed');
								if(
									($field = $input.closest('.base_form_elements_field')).length > 0 ||
									($field = $input.closest('.form-group')).length > 0
								){
									$field.find('.validationError').remove();
									$field.removeClass('validationFailed');
								} else {
									$input.parent().find('.validationError').remove()
								}
							}
							// field is invalid
							else {
								// remove old error messages
								$input.addClass('validationFailed');
								var $newErrorMessage = $('<div class="validationError">' + validationResult.fields[validationFieldCode] + '</div>');

								if(
									($field = $input.closest('.base_form_elements_field')).length > 0 ||
									($field = $input.closest('.form-group')).length > 0
								){
									$field.find('.validationError').remove();
									$field.prepend($newErrorMessage);
									$field.addClass('validationFailed');
								}
								else {
									$input.parent().find('.validationError').remove();
									$newErrorMessage.insertBefore($input);
								}

								// set focus if necessary
								if(firstError){
									firstError = false
									$input.focus();
								}
							}
						}
					}

					// tell relationship parent that an error occurred
					if(this.config.isRelationshipChild){
						if(typeof(this.parentForm.handleRelationshipChildValidationError) === 'function'){
							this.parentForm.handleRelationshipChildValidationError(this, validationResult, firstInvalidValidationResult);
						}
					}

					break;
			}

			return false
		},

		/**
		 * this function is used to reperform validation and handle its' results.
		 *
		 * @param fieldCode
		 */
		processValidation: function(fieldCode){
			var fieldProperties = this.getFieldProperties(fieldCode) || {};
			var validatorAttributes = [];

			if(this.model.dirtyFields && this.model.dirtyFields.data && this.model.dirtyFields.data.attributes){
				if(fieldProperties.relatedFieldCode && fieldProperties.writeSimpleParentJsonAttribute && this.model.dirtyFields.data.attributes[fieldProperties.relatedFieldCode]){
					validatorAttributes.push(this.model.dirtyFields.data.attributes[fieldProperties.relatedFieldCode]);
				}
				validatorAttributes.push(this.model.dirtyFields.data.attributes);
			}
			if(this.resourceData.data && this.resourceData.data.attributes) {
				if(fieldProperties.relatedFieldCode && fieldProperties.writeSimpleParentJsonAttribute && this.resourceData.data.attributes[fieldProperties.relatedFieldCode]){
					validatorAttributes.push(this.resourceData.data.attributes[fieldProperties.relatedFieldCode]);
				}
				validatorAttributes.push(this.resourceData.data.attributes);
			}
			var validatorFieldCodes = {};
			var attributeKey;
			if(fieldProperties) attributeKey = fieldProperties.attributeKey;
			// TODO: VALIDATION ERROR SOURCE?!
			validatorFieldCodes[attributeKey || fieldCode] = true;
			var validationResult = this.validate(validatorAttributes, validatorFieldCodes, this.model.namedFields);
			this.handleValidationResult(validationResult, validationResult.invalid);
		},

		/**
		 * this function returns a list of dirty fieldKeys of this form and all of its' sub-forms.
		 * NOTE: child flags can overwrite parents. there is no parentType included (like children, relationships, ...)
		 *
		 * @returns [] - dirty elements fieldKeys (includes only fieldKeys of values which can be changed by the user)
		 */
		getDirties: function(){
			// init
			var self    = this;
			var dirties = {};
			var formName = self.config.subFormAlias || self.config.defaultFormName;
			var templateAtomID;
			if(!dirties[formName]) dirties[formName] = { _length: 0 };

			if(this.model.dirtyFields && this.model.dirtyFields.data){
				utils.forEach(Array.isArray(this.model.dirtyFields.data) ? this.model.dirtyFields.data : [this.model.dirtyFields.data], function(data){
					// NOTE: component content forms have multiple dataJSON and other data-fields. so the templateAtomID has to be taken into account during dirty field recognition.
					templateAtomID = -1;
					if(self.config.componentDataDependentFieldAssociation && data.attributes && data.attributes.templateAtomID){
						templateAtomID = data.attributes.templateAtomID;
					}

					// check all attributes
					utils.forEach(data.attributes || [], function(fieldValue, fieldKey){
						// templateAtomIDs will never be data instead of data-identifiers. so they can't be dirty.
						if(fieldKey != 'templateAtomID'){
							// check if dirtyField has been defined by an external logic or not
							utils.forEach(self.model.fieldProperties, function(fieldProperties, fieldPropertiesKey){
								// prevent primaryKey special fields from marking forms as dirty.
								if(fieldPropertiesKey != 'primaryKey' && fieldProperties.attributeKey == fieldKey && (!self.config.componentDataDependentFieldAssociation || self.config.isFieldCodeSelector || (fieldProperties.staticFields && fieldProperties.staticFields.templateAtomID == templateAtomID))){
									dirties[formName][fieldKey + (templateAtomID < 0 ? '~' : '-' + templateAtomID)] = true;
									dirties[formName]._length++;
								}
							});
						}
					});

					// check bound relations if necessary
					if(data.relations || data.children){
						utils.forEach(self.model.fieldProperties, function(fieldProperties, fieldPropertiesKey){
							// prevent primaryKey special fields from marking forms as dirty.
							if(
								fieldPropertiesKey != 'primaryKey' &&
								fieldProperties.relationConfig &&
								fieldProperties.relationConfig.subFormAliasContainer &&
								data[fieldProperties.relationConfig.subFormAliasContainer] &&
								fieldProperties.relationConfig.subFormAlias &&
								data[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias] &&
								data[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data &&
								data[fieldProperties.relationConfig.subFormAliasContainer][fieldProperties.relationConfig.subFormAlias].data.length > 0
							){
								dirties[formName]['relation_' + fieldProperties.fieldCode] = true;
								dirties[formName]._length++;
							}
						});
					}
				});
			}

			// check dirty state of sub-forms
			// NOTE: this is necessary to get children- and relationships- data-attributes checked appropriate according to their default values.
			// NOTE: relationship children have to sum up their _length flags to prevent values overwritten by zero.
			var subFormDirties;
			var relationshipChildDirtiesLength = 0;
			var subFormName;
			self.forEachSubForm(function(subFormComponent){
				subFormDirties = subFormComponent.getDirties();
				if(subFormComponent.config.isRelationshipChild){
					subFormName = subFormComponent.config.subFormAlias || self.config.defaultFormName;
					if(subFormDirties[subFormName] && subFormDirties[subFormName]._length){
						relationshipChildDirtiesLength += subFormDirties[subFormName]._length;
					}
					subFormDirties[subFormName]._length = relationshipChildDirtiesLength;
				}

				utils.refMerge(dirties, subFormDirties);
			});

			return dirties;
		},

		/**
		 * this function is used to force this form as dirty.
		 * NOTE: this should be used with caution because the default dirty checks won't be done any longer if this flag is set.
		 */
		setDirty: function(){
			this.config.forceDirty = true;
		},

		/**
		 * this function is the opposite of the setDirty-Method.
		 * NOTE: it is used to get this form working as normal (dirty checks will be done again).
		 */
		setClean: function(){
			this.config.forceDirty = false;
		},

		/**
		 * resets all dirty fields of this form and all children forms
		 */
		resetDirties: function(){
			this.model.dirtyFields = {};
			// reset dirty fields of subForms
			this.forEachSubForm(function(subFormComponent){
				subFormComponent.model.dirtyFields = {};
			});

			this.triggerFind('resetDirties');
		},

		/**
		 * this function is used to perform a submit request
		 */
		submit: function(){
			const self    = this;

			// check if at least one child has to block this submit
			return self.prepareChildrenForSubmit().then(function(context){
				var dirties = self.getDirties();
				var isDirty = self.config.creationMode || self.config.copyMode || self.config.forceDirty;
				var formName;
				if(!isDirty){
					for(formName in dirties){
						if(dirties[formName]._length > 0){
							isDirty = true;
							break;
						}
					}
				}

				// give all forms the chance to react on submit event and validate forms
				var validationResult = {};
				self.onBeforeSubmit(isDirty || self.config.forceNonDirtyValidation, dirties, validationResult);

				// check if validation error occured
				if(!validationResult.invalid){
					if(self.model.preventSubmit){
						return utils.promise.reject('preventSubmit');
					}

					// call handler for other components
					self.callHandler('beforeSubmit');

					if(isDirty){
						var data = {};
						if(self.config.copyMode)	self.replaceResourceAttributes(data, self.resourceData, self.model.dirtyFields);
						else 						data = utils.simpleCopy(self.model.dirtyFields);

						// TODO: check multi user resource submit race conditions
						data._resourceLoadTimestamp = '...';
						data._serverSpawnTimestamp = '...';

						// send primaryKey definition
						if(data.data && !data.data.primaryKey && self.resourceData.data && self.resourceData.data.primaryKey){
							data.data.primaryKey = self.resourceData.data.primaryKey;
						}

						// prepare protocolAction dependent data if necessary
						if((self.resourceData.meta || {}).protocolActionLoadingTS){
							data.meta = data.meta || {}
							data.meta.protocolActionLoadedData = utils.replace(self.resourceData, { debug: undefined })
						}

						// prevent submit of protocolActionForm
						if(self.config.isProtocolActionForm){
							return utils.promise.resolve();
						}

						var submitPromise;
						if(utils.isFunction(self.customSubmit)){
							submitPromise = self.customSubmit(data)
						} else {
							submitPromise = self.performAction(self.prepareAction('submit', undefined, undefined, {
								source: {
									submit: {
										data: data
									}
								}
							}))
						}

						return submitPromise.then(function(context){
							// insertion done?
							var insertionDone = context.component.config.creationMode || context.component.config.copyMode;

							// set saved values within model if this form is not a static used creation-form
							if(context.component.config.isStaticForm){
								if (context.component.config.resetDirtyFieldsAfterSuccessfulSubmit){
									// reset dirties if this form will be reused within actions and this form is within the creationMode state.
									context.component.resetDirties();
								}
							}
							else {
								utils.refMerge(context.component.resourceData, context.response)

								// reset dirtyFields if necessary
								if (context.component.config.resetDirtyFieldsAfterSuccessfulSubmit){
									context.component.resetDirties()
								}
							}

							// call handler for this component
							context.component.onSubmit(context.response, insertionDone)

							// call handler for other components
							context.component.callHandler('onSubmitDone', [context.response, insertionDone, context.component.config.onSubmitDoneHandlerOptions || {}])

							// if a component had the forceDirty flag it has to be gone after submitting this form
							context.component.setClean()

							var statusController;
							if(context.component.config.onSubmitDonePanelMessage && (statusController = getComponent('statusController')) && !context.forceActionSuccess){
								statusController.addPanel(context.component.config.onSubmitDonePanelMessage)
							}

							return utils.promise.resolve(context)
						});
					}
					else {

						// call handler for this component
						self.onSubmitNothing()

						// call handler for other components
						self.callHandler('onSubmitNothing')

						// TODO: nothing changed action?!
						var statusController;
						if((statusController = getComponent('statusController'))){
							statusController.addPanel('status.nothingChanged');
						}
						return utils.promise.reject('nonDirty');
					}
				}

				return utils.promise.reject('validationFailed')
			});
		},

		/**
		 * this function is used to submit if changes where made and config.autoSubmitOnChange is turned on.
		 */
		autoSubmit(){
			// auto submit if necessary
			if(this.config.autoSubmitOnChange && !this.parentForm && !this.config.creationMode && this.config.resourceConnected){
				const dirties = this.getDirties()
				let dirtyFound = false
				for(const formKey in dirties){
					if((dirties[formKey] || {})._length > 0){
						dirtyFound = true
						break
					}
				}

				if(dirtyFound){
					if(this.model.autoSubmitTimeout){
						clearTimeout(this.model.autoSubmitTimeout)
					}
					this.model.autoSubmitTimeout = setTimeout(() => {
						this.submit()
					}, 30)
				}
			}
		},

		/**
		 * reset all dirties and refresh form
		 */
		reset: function(){
			this.resetDirties();
			this.refresh(false);
		},

		/**
		 * this function returns the index within the model.fields[] according to the given fieldCode.
		 *
		 * @param   fieldCode       string - fieldCode
		 * @returns                 int - model.fields[] index || -1 if the given fieldCode cannot be found
		 */
		getModelFieldIndex: function(fieldCode){
			var modelFieldIndex;

			if(fieldCode){
				utils.forEach(this.model.fields, function(field, fieldIndex){
					if(field.fieldCode == fieldCode){
						modelFieldIndex = fieldIndex;
						return false;
					}
				});

				if(typeof(modelFieldIndex) !== 'undefined'){
					return modelFieldIndex;
				}
			}

			return -1;
		},

		/**
		 * this function is used to translate values from its' resource-form to the needed model-form.
		 *
		 * @param   fieldValue          value of the field
		 * @param   fieldProperties     fieldProperties of this field
		 * @returns mixed               fieldValue which can be used as value within the model.fields[...] structure of the field defined by the given fieldProperties.
		 */
		resourceToModelValue: function(fieldValue, fieldProperties){
			if(!utils.isCollection(fieldValue)){
				switch(fieldProperties.dataType){
					case 'category-picker': 		return [fieldValue];
					case 'resource-picker': 		return [fieldValue];
					case 'tag-picker': 				return [fieldValue];
					case 'route-picker': 			return [fieldValue];
					case 'route-component-picker': 	return [fieldValue];
				}
			}

			return fieldValue;
		},

		/**
		 * this function is used to save a merge of the preexisting fieldProperties identified by the given fieldCode and the given ones.
		 *
		 * @param fieldCode             string - fieldCode
		 * @param fieldProperties       object - fieldProperties
		 */
		setFieldProperties: function(fieldCode, fieldProperties){
			this.model.fieldProperties[fieldCode] = this.sanitizeFieldProperties(fieldCode, utils.simpleMerge(this.model.fieldProperties[fieldCode] || {}, fieldProperties));
		},

		/**
		 * this function returns the fieldProperties identified by the given fieldCode
		 *
		 * @param   fieldCode       string - fieldCode
		 * @returns                 {} - fieldProperties
		 */
		getFieldProperties: function(fieldCode){
			return this.model.fieldProperties[fieldCode] || {}
		},

		/**
		 * this function is used to sanitize and return the given fieldProperties.
		 * this logic handles default values and some fieldProperty-Dependencies.
		 *
		 * @param   fieldCode           string - fieldCode
		 * @param   fieldProperties     object - fieldProperties
		 * @returns                     {} - fieldProperties
		 */
		sanitizeFieldProperties: function(fieldCode, fieldProperties){
			if(this.config.isFieldCodeSelector){
				if(fieldProperties.parentJSONFieldCode){
					fieldProperties.attributeKey = `${fieldProperties.parentJSONFieldCode}_${this.model.resourceAttributeMapping[fieldCode]}`
				} else {
					fieldProperties.attributeKey = this.model.resourceAttributeMapping[fieldCode]
				}
				fieldProperties.modelFieldAttributeKey = 'dataINT'
			} else {
				// set attribute key according to resource mapping
				if(this.model.resourceAttributeMapping[fieldCode] !== undefined){
					fieldProperties.attributeKey = this.model.resourceAttributeMapping[fieldCode];
				}

				// set attribute key according to data type if this is a special components_data form
				if(this.config.componentDataDependentFieldAssociation){
					fieldProperties.attributeKey = utils.getDataValueKey(fieldProperties.dataType);
				}

				// set model field attribute key according to the data type if a model field exists for this specific field (default equals to attribute key)
				if(fieldProperties.modelFieldIndex !== undefined){
					fieldProperties.modelFieldAttributeKey = utils.getDataValueKey(fieldProperties.dataType);
				}
				else {
					fieldProperties.modelFieldAttributeKey = fieldProperties.attributeKey;
				}

				// set flag if the selection of the default value for this field via first available option is granted or not
				if(fieldProperties.firstOptionSelectionGranted === undefined){
					fieldProperties.firstOptionSelectionGranted = (fieldProperties.renderType === 'select' || fieldProperties.renderType === 'toggle')
				}
			}

			return fieldProperties;
		},

		/**
		 * this function is used to sanitize the fieldProperties of all fields according to the fieldCodeDependency feature.
		 */
		sanitizeFieldCodeDependencyFieldProperties: function(){
			var self = this;
			utils.forEach(self.model.fieldProperties, function(fieldProperties, fieldCode){
				// register field dependencies
				if(fieldProperties.hasFieldCodeDependency && utils.collectionSize(fieldProperties.fieldCodeDependencyList) > 0){
					utils.forEach(fieldProperties.fieldCodeDependencyList, function(foreignFieldCode, foreignFieldCodeAlias){
						if(self.model.fieldProperties[foreignFieldCode]){
							self.model.fieldProperties[foreignFieldCode].hasFieldCodeDependency = true;
							self.model.fieldProperties[foreignFieldCode].fieldCodeAlias = foreignFieldCodeAlias;
							self.model.fieldProperties[foreignFieldCode].relatedFieldCode = fieldCode;
						}
						else {
							console.warn('fieldCodeDependency not resolvable: ' + foreignFieldCode);
						}
					});
				}

				// register additional attribute dependencies
				if(fieldProperties.hasAdditionalAttributes && utils.collectionSize(fieldProperties.handleAdditionalAttributes) > 0){
					utils.forEach(fieldProperties.handleAdditionalAttributes, function(value, foreignFieldCode){
						if(self.model.fieldProperties[foreignFieldCode]){
							self.model.fieldProperties[foreignFieldCode].isAdditionalAttribute = true;
							self.model.fieldProperties[foreignFieldCode].relatedFieldCode = fieldCode;
						}
						else {
							// TODO: throw error?
							console.error('handleAdditionalAttributes not resolvable: ' + foreignFieldCode);
						}
					});
				}
			});
		},

		/**
		 * this function is used to copy the dirtyFields of a subForm into the own dirtyFields
		 *
		 * @param subFormAlias          	string - subFormAlias
		 * @param subDirtyFields       		object - dirty fields of subForm
		 * @param subIsRelationshipChild	boolean - sub is relationship child or not
		 * @param subDataIndex          	int - optional - dataIndex (used e.g., for relationShipData
		 * @param subFormResourceKey    	string - optional - resourceKey of subForm (children | relations at the moment)
		 * @param isSingleRelationship    	boolean - optional - is this a single relationship without any separators
		 */
		subFieldsToModel: function(subFormAlias, subDirtyFields, subIsRelationshipChild, subDataIndex, subFormResourceKey, isSingleRelationship){
			// set data according to new dataIndex
			if(subIsRelationshipChild && subDataIndex == undefined && !isSingleRelationship){
				// TODO: cleanup hack for image details cleanup
				if(this.model.dirtyFields.data){
					if(!Array.isArray(this.model.dirtyFields.data)){
						var dataIndex;
						var newData = [];
						for(dataIndex in this.model.dirtyFields.data){
							if(dataIndex == parseInt(dataIndex)){
								newData.push(this.model.dirtyFields.data[dataIndex]);
							}
						}
						this.model.dirtyFields.data = newData;
						subDataIndex = newData.length;
					}
					else {
						subDataIndex = this.model.dirtyFields.data.length;
					}
				}
				else if(this.resourceData.data && Array.isArray(this.resourceData.data)){
					subDataIndex = this.resourceData.data.length;
				}
				else {
					subDataIndex = 0;
				}
			}

			// set data according to dataIndex
			if(subDataIndex != undefined){
				if(this.model.dirtyFields.data === undefined) this.model.dirtyFields.data = [];
				this.model.dirtyFields.data[subDataIndex] = subDirtyFields.data;

				// in case of cascading subForms the submitAllResources-flag has to be respected even if no other field within this form has been changed.
				if(this.config.submitAllResources && !utils.isEmpty(this.resourceData.data[subDataIndex])){
					this.model.dirtyFields.data[subDataIndex] = utils.fullReplace(
						this.resourceData.data[subDataIndex],
						this.model.dirtyFields.data[subDataIndex],
					);
				}
			}
			// simply set data
			else {
				if(this.model.dirtyFields.data === undefined)                   	this.model.dirtyFields.data = {};
				if(this.model.dirtyFields.data[subFormResourceKey] === undefined)  	this.model.dirtyFields.data[subFormResourceKey] = {};

				let basicFields
				if(isSingleRelationship){
					if(subIsRelationshipChild){
						basicFields = (this.resourceData.data || {}).attributes
						this.model.dirtyFields.data[subFormResourceKey][subFormAlias] = ((subDirtyFields || {}).data || {}).attributes;
					} else {
						basicFields = ((this.resourceData.data || {})[subFormResourceKey] || {})[subFormAlias]
						this.model.dirtyFields.data[subFormResourceKey][subFormAlias] = (((subDirtyFields || {}).data || {})[subFormResourceKey] || {})[subFormAlias];
					}
				} else {
					basicFields = ((this.resourceData.data || {})[subFormResourceKey] || {})[subFormAlias]
					this.model.dirtyFields.data[subFormResourceKey][subFormAlias] = subDirtyFields;
				}

				// in case of cascading subForms the submitAllResources-flag has to be respected even if no other field within this form has been changed.
				if(this.config.submitAllResources && !utils.isEmpty(basicFields)){
					this.model.dirtyFields.data[subFormResourceKey][subFormAlias] = utils.fullReplace(
						basicFields,
						this.model.dirtyFields.data[subFormResourceKey][subFormAlias],
					);
				}

				if(this.config.resourceConnected){
					// set globalStaticFields in dirty fields for later usage if necessary
					if(this.config.creationMode){
						if(!utils.isEmpty(this.model.globalStaticFields)){
							utils.forEach(this.model.globalStaticFields, (defaultValue, fieldCode) => {
								if(this.getFieldValue(fieldCode, 'dirty') === undefined){
									this.fieldToModel(fieldCode, defaultValue)
								}
							});
						}
					}

					// set own primaryKey in dirty fields for later usage if necessary
					if(!this.config.creationMode && !this.config.copyMode){
						this.fieldToModel('primaryKey')
					}
				}
			}

			// tell parent-parent-...-forms the new dirtyFields
			if(this.config.subFormAlias && !!this.parentForm){
				if(this.config.isRelationshipChild){
					this.config.relationshipDataIndex = this.parentForm.subFieldsToModel(this.config.subFormAlias, this.model.dirtyFields, true, this.config.relationshipDataIndex, this.config.parentFormResourceKey, (this.parentForm.config.availableSeparators || {}).type === 'single');
				}
				else {
					this.parentForm.subFieldsToModel(this.config.subFormAlias, this.model.dirtyFields, false, undefined, this.config.parentFormResourceKey, (this.config.availableSeparators || {}).type === 'single');
				}
			}

			// call on-change-handler for extended forms.
			this.onChange();

			this.autoSubmit()

			return subDataIndex;
		},

		/**
		 * this function is used to get a fields' value into the model
		 *
		 * TODO: async changes
		 *
		 * @param fieldCode                     string - fieldcode
		 * @param fieldValue                    mixed - fieldvalue
		 * @param forceModelFieldValueChange    boolean - force that the fields' value will be set within the model.fields too (instead of the model.dirtyFields only).
		 *                                      NOTE: usually the model.fields of creation forms will be left untouched.
		 * @param dependencyCall 				boolean - is this a dependencyCall
		 * 										NOTE: must not be used from outside
		 * @param grantAbortOnEmptyDirtyFields 	boolean - may this method abort if the data of the current field has not been changed.
		 * 										NOTE: must not be used from outside
		 * 										NOTE: is used for special cases to prevent problems on separated fields
		 */
		fieldToModel(fieldCode, fieldValue, forceModelFieldValueChange, dependencyCall, grantAbortOnEmptyDirtyFields = true){
			var self = this;
			var primaryKeyInCharge = false;
			var originalFieldValue, originalFieldProperties;

			// @see: MARK: FORM_PREVENT_DIRTIES for further details
			if(self.model.preventDirties) return;

			// in fieldCodeSelector mode the normal fields should not be able to write their own default values.
			// instead the wrapper fields should be written.
			if(this.config.isFieldCodeSelector && fieldCode){
				if(String(fieldCode).match(/^wrapper_/) === null) return;
				fieldCode = String(fieldCode).replace(/^wrapper_/, '')
			}

			if(fieldCode === 'primaryKey'){
				primaryKeyInCharge = true;

				if(
					!this.resourceData.data ||
					!this.resourceData.data.primaryKey ||
					!this.resourceData.data.attributes ||
					!this.resourceData.data.attributes[this.resourceData.data.primaryKey]
				){
					return;
				}
				fieldValue = this.resourceData.data.attributes[this.resourceData.data.primaryKey];
			}

			// NOTE: null is an allowed fieldValue
			if(fieldValue === undefined){
				// TODO: throw error
				console.error('undefined fieldValue @ ' + fieldCode);
			}

			var fieldProperties = this.getFieldProperties(fieldCode);

			// set dependent fields according to the given value
			if(fieldProperties.hasFieldCodeDependency){
				if(utils.collectionSize(fieldProperties.fieldCodeDependencyList) > 0){
					utils.forEach(fieldProperties.fieldCodeDependencyList, function(foreignFieldCode, foreignFieldCodeAlias, isFirstEntry, isLastEntry){
						const usedFieldValue = fieldValue || {} // if fieldValue is null neither the foreignFieldCode nor the foreignFieldCodeAlias may be accessed.
						if(usedFieldValue[foreignFieldCode] !== undefined) 	self.fieldToModel(foreignFieldCode, usedFieldValue[foreignFieldCode], forceModelFieldValueChange, !isLastEntry, false);
						else 												self.fieldToModel(foreignFieldCode, usedFieldValue[foreignFieldCodeAlias], forceModelFieldValueChange, !isLastEntry, false);
					});
					return;
				}
				// write separated field change into json parent (as an attribute) if necessary
				else if (fieldProperties.relatedFieldCode && fieldProperties.writeSimpleParentJsonAttribute) {
					var relatedFieldProperties = this.getFieldProperties(fieldProperties.relatedFieldCode);
					if(relatedFieldProperties.attributeKey && relatedFieldProperties.dataType === 'json') {
						var parentJsonValue = {};
						if(relatedFieldProperties.dataIndex !== undefined){
							parentJsonValue = utils.simpleCopy(
								((((this.model.dirtyFields || {}).data || [])[relatedFieldProperties.dataIndex] || {}).attributes || {})[relatedFieldProperties.attributeKey]
								||
								(((this.resourceData.data || [])[relatedFieldProperties.dataIndex] || {}).attributes || {})[relatedFieldProperties.attributeKey]
								||
								{}
							);
						} else {
							parentJsonValue = utils.simpleCopy(
								(((this.model.dirtyFields || {}).data || {}).attributes || {})[relatedFieldProperties.attributeKey]
								||
								((this.resourceData.data || {}).attributes || {})[relatedFieldProperties.attributeKey]
								||
								{}
							);
						}

						originalFieldValue = fieldValue;
						originalFieldProperties = fieldProperties;
						parentJsonValue[fieldProperties.fieldCodeAlias || fieldProperties.fieldCode] = fieldValue;
						fieldValue = parentJsonValue;
						fieldProperties = relatedFieldProperties;
					}
				}
			}

			// identify field to write to
			if(fieldProperties.attributeKey !== undefined){
				let crudType = 'update'
				if(self.config.isProtocolActionForm){
					crudType = 'read'
				} else if(self.config.creationMode){
					crudType = 'create'
				}

				if(!self.hasAttributeAccessTo(fieldProperties.attributeKey, crudType)){
					self.performAction(self.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:notAllowed.form.field'
						}
					}));

					self.refresh(false);
					return;
				}

				// prepare
				var defaultValue, nrOfDynamicAttributes, staticFields, globalStaticFields, baseStaticFields;

				// should the field be written to a data index
				if(fieldProperties.dataIndex !== undefined){
					defaultValue =
						this.config.creationMode ||
						!Array.isArray(this.resourceData.data) ||
						this.resourceData.data[fieldProperties.dataIndex] == undefined ||
						this.resourceData.data[fieldProperties.dataIndex].attributes == undefined
							? undefined
							: this.resourceData.data[fieldProperties.dataIndex].attributes[fieldProperties.attributeKey]
					;

					// delete field value from dirtyFields when value equals default value
					// TODO: check other fieldValues which should be removed when defaultValue is undefined (like zero, null, ...)
					if(!fieldProperties.preferEmptyValuePresence && (defaultValue == fieldValue || (defaultValue === undefined && fieldValue === ""))){
						if(this.model.dirtyFields.data !== undefined && this.model.dirtyFields.data[fieldProperties.dataIndex] !== undefined && this.model.dirtyFields.data[fieldProperties.dataIndex].attributes !== undefined){
							delete this.model.dirtyFields.data[fieldProperties.dataIndex].attributes[fieldProperties.attributeKey];
						}
					}
					// set field value in dirtyFields
					else {
						if(this.model.dirtyFields.data === undefined)                                       this.model.dirtyFields.data = [];
						if(this.model.dirtyFields.data[fieldProperties.dataIndex] === undefined)            this.model.dirtyFields.data[fieldProperties.dataIndex] = {};
						if(this.model.dirtyFields.data[fieldProperties.dataIndex].attributes === undefined) this.model.dirtyFields.data[fieldProperties.dataIndex].attributes = {};

						this.model.dirtyFields.data[fieldProperties.dataIndex].attributes[fieldProperties.attributeKey] = fieldValue;
					}

					// add or remove primary key and staticFields if necessary
					staticFields        = fieldProperties.staticFields || {};
					globalStaticFields  = {};
					baseStaticFields  	= {};
					if(this.resourceData && this.resourceData.data && this.resourceData.data[fieldProperties.dataIndex] && this.resourceData.data[fieldProperties.dataIndex].attributes){
						if(this.resourceData.data[fieldProperties.dataIndex].attributes[this.resourceData.data[fieldProperties.dataIndex].primaryKey]) {
							globalStaticFields[this.resourceData.data[fieldProperties.dataIndex].primaryKey] = this.resourceData.data[fieldProperties.dataIndex].attributes[this.resourceData.data[fieldProperties.dataIndex].primaryKey];
						}
						if(this.config.isRelationshipChild && this.config.separatorKey && this.resourceData.data[fieldProperties.dataIndex].attributes[this.config.separatorKey] && (this.config.availableSeparators || {}).type !== 'dataIndex') {
							globalStaticFields[this.config.separatorKey] = this.resourceData.data[fieldProperties.dataIndex].attributes[this.config.separatorKey];
						}
						if(!utils.isEmpty(this.model.globalStaticFields)){
							utils.forEach(this.model.globalStaticFields, function(defaultValue, fieldCode){
								globalStaticFields[fieldCode] = self.resourceData.data[fieldProperties.dataIndex].attributes[fieldCode] || defaultValue;
							});
						}
					}
					else if(!utils.isEmpty(this.model.globalStaticFields)){
						utils.forEach(this.model.globalStaticFields, function(defaultValue, fieldCode){
							globalStaticFields[fieldCode] = defaultValue;
						});
					}
					if(this.config.submitAllResources && utils.collectionSize((this.resourceData.data || {}).attributes) > 0){
						utils.forEach(this.resourceData.data.attributes, function(value, fieldCode){
							baseStaticFields[fieldCode] = value;
						});
					}

					// exit if nothing changed (e.g. html-editor button)
					const emptyDirtyField = !this.model.dirtyFields.data || !this.model.dirtyFields.data[fieldProperties.dataIndex]
					if (grantAbortOnEmptyDirtyFields && emptyDirtyField) return true;

					if(!emptyDirtyField){
						if(!utils.isEmpty(globalStaticFields)) staticFields = utils.merge(staticFields, globalStaticFields);
						nrOfDynamicAttributes   = utils.collectionSize(utils.remove(this.model.dirtyFields.data[fieldProperties.dataIndex].attributes, staticFields));

						// no dynamic attributes found?
						if(nrOfDynamicAttributes <= 0 && !this.config.submitAllResources){
							this.model.dirtyFields.data[fieldProperties.dataIndex].attributes = utils.remove(
								this.model.dirtyFields.data[fieldProperties.dataIndex].attributes,
								staticFields
							);
						}
						// should static fields be added?
						else if(nrOfDynamicAttributes == utils.collectionSize(this.model.dirtyFields.data[fieldProperties.dataIndex].attributes) || this.config.submitAllResources){
							this.model.dirtyFields.data[fieldProperties.dataIndex].attributes = utils.fullReplace(
								baseStaticFields,
								this.model.dirtyFields.data[fieldProperties.dataIndex].attributes,
								staticFields
							);
						}
					}
				}
				else {
					defaultValue = this.config.creationMode || primaryKeyInCharge ? undefined : (((this.resourceData || {}).data || {}).attributes || {})[fieldProperties.attributeKey];
					if(this.model.dirtyFields.data === undefined){
						this.model.dirtyFields.data = {};
					}

					// delete field value from dirtyFields when value equals default value
					// TODO: check other fieldValues which should be removed when defaultValue is undefined (like zero, null, ...)
					if(!fieldProperties.preferEmptyValuePresence && (defaultValue == fieldValue || (defaultValue === undefined && fieldValue === ""))){
						if(this.model.dirtyFields.data !== undefined && this.model.dirtyFields.data.attributes !== undefined){
							delete this.model.dirtyFields.data.attributes[fieldProperties.attributeKey];
						}
					}
					// set field value in dirtyFields
					else {
						if(this.model.dirtyFields.data.attributes === undefined){
							this.model.dirtyFields.data.attributes = {};
						}

						this.model.dirtyFields.data.attributes[fieldProperties.attributeKey] = fieldValue;
					}

					// add or remove primary key and staticFields if necessary
					staticFields        = fieldProperties.staticFields || {};
					globalStaticFields  = {};
					baseStaticFields 	= {};
					if(this.resourceData && this.resourceData.data && this.resourceData.data.attributes){
						if(this.resourceData.data.attributes[this.resourceData.data.primaryKey]) {
							globalStaticFields[this.resourceData.data.primaryKey] = this.resourceData.data.attributes[this.resourceData.data.primaryKey];
						}
						if(this.config.isRelationshipChild && this.parentForm.config.separatorKey && this.resourceData.data.attributes[this.parentForm.config.separatorKey] && (this.config.availableSeparators || {}).type !== 'dataIndex') {
							globalStaticFields[this.parentForm.config.separatorKey] = this.resourceData.data.attributes[this.parentForm.config.separatorKey];
						}
						if(!utils.isEmpty(this.model.globalStaticFields)){
							utils.forEach(this.model.globalStaticFields, function(defaultValue, fieldCode){
								globalStaticFields[fieldCode] = self.resourceData.data.attributes[fieldCode] || defaultValue;
							});
						}
					}
					else if(!utils.isEmpty(this.model.globalStaticFields)){
						utils.forEach(this.model.globalStaticFields, function(defaultValue, fieldCode){
							globalStaticFields[fieldCode] = defaultValue;
						});
					}
					if(this.config.submitAllResources && utils.collectionSize((this.resourceData.data || {}).attributes) > 0){
						utils.forEach(this.resourceData.data.attributes, function(value, fieldCode){
							baseStaticFields[fieldCode] = value;
						});
					}
					if(!utils.isEmpty(globalStaticFields)) staticFields = utils.merge(staticFields, globalStaticFields);

					if(this.model.dirtyFields.data.attributes){
						nrOfDynamicAttributes = utils.collectionSize(utils.remove(this.model.dirtyFields.data.attributes, staticFields));
					} else {
						nrOfDynamicAttributes = 0
					}

					// no dynamic attributes found?
					if(!primaryKeyInCharge && nrOfDynamicAttributes <= 0 && !this.config.submitAllResources){
						this.model.dirtyFields.data.attributes = {}
					}
					// should static fields be added?
					else if(primaryKeyInCharge || nrOfDynamicAttributes == utils.collectionSize((this.model.dirtyFields.data || {}).attributes) || this.config.submitAllResources){
						this.model.dirtyFields.data = this.model.dirtyFields.data || {}
						this.model.dirtyFields.data.attributes = utils.fullReplace(
							baseStaticFields,
							this.model.dirtyFields.data.attributes,
							staticFields
						);
					}
				}

				// set dirty fields' values to model too if necessary
				// NOTE: if this is an insertion form a refresh would need an original model after any action (cancel or submit)
				if((!this.config.creationMode || this.config.dirtyModelPersistent || forceModelFieldValueChange) && !primaryKeyInCharge){
					this.model.fields[fieldProperties.modelFieldIndex][fieldProperties.modelFieldAttributeKey] = this.resourceToModelValue(fieldValue, fieldProperties);

					// in case of simpleParentJSON usage the original field has to be written to.
					if(originalFieldProperties){
						this.model.fields[originalFieldProperties.modelFieldIndex][originalFieldProperties.modelFieldAttributeKey] = this.resourceToModelValue(originalFieldValue, originalFieldProperties);
					}
				}

				// tell dependent fields about changes of this additional attribute
				if(fieldProperties && fieldProperties.isAdditionalAttribute && fieldProperties.relatedFieldCode){
					var relatedFieldProperties = this.getFieldProperties(fieldProperties.relatedFieldCode);
					if(relatedFieldProperties.attributeKey) {
						var relatedField = this.model.fields[relatedFieldProperties.modelFieldIndex]
						if(!relatedField.additionalAttributes) relatedField.additionalAttributes = {}
						relatedField.additionalAttributes[fieldProperties.attributeKey] = this.resourceToModelValue(fieldValue, fieldProperties);
					}
				}
			}

			if(!dependencyCall){
				if(!primaryKeyInCharge && this.config.subFormAlias && !!this.parentForm){
					if(this.config.isRelationshipChild){
						this.config.relationshipDataIndex = this.parentForm.subFieldsToModel(this.config.subFormAlias, this.model.dirtyFields, true, this.config.relationshipDataIndex, this.config.parentFormResourceKey, (this.parentForm.config.availableSeparators || {}).type === 'single');
					}
					else {
						this.parentForm.subFieldsToModel(this.config.subFormAlias, this.model.dirtyFields, false, undefined, this.config.parentFormResourceKey, (this.config.availableSeparators || {}).type === 'single');
					}
				}
				else {
					// call on-change-handler for extended forms.
					this.onChange(false, undefined, {
						fieldCode,
						fieldValue: originalFieldValue || fieldValue
					});
				}
			}

			// validate changed resources
			this.processValidation(fieldCode);

			this.autoSubmit()

			return true;
		},

		// TODO: DOC!
		// TODO: async changes
		relationFieldToModel(fieldData){
			var self = this;

			// @see: MARK: FORM_PREVENT_DIRTIES for further details
			if(self.model.preventDirties) return;

			// NOTE: null is an allowed fieldValue
			if(fieldData.value === undefined){
				// TODO: throw error
				console.error('undefined fieldValue @ ' + fieldData.fieldCode);
			}
			if(!fieldData.relationConfig){
				// TODO: throw error
				console.error('undefined fieldData.relationConfig @ ' + fieldData.fieldCode);
			}

			// identify field to write to
			if(fieldData.relationConfig.privilegeCode !== undefined && fieldData.type != 'keep'){
				if(!self.hasAccessTo(fieldData.relationConfig.privilegeCode, fieldData.type)){
					self.performAction(self.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:notAllowed.form.field'
						}
					}));

					self.refresh(false);
					return;
				}
			}

			var changeDone = true;
			if(fieldData.type === 'keep' || fieldData.type === 'ignore'){
				// cleanup dirtyFields
				if(
					this.model.dirtyFields.data &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer] &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias] &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data[fieldData.relationDataIndex]
				){
					// TODO: CHECK SPLICE SETTER?!
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data.splice(fieldData.relationDataIndex, 1);

					// set own primaryKey in dirty fields for later usage if necessary.
					// e.g., this may happen if a componentContentForm has been loaded to handle a componentInstance without a primaryKey and only the componentInstances tags has been changed.
					// this would lead to a PATCH request whose url contains no primaryKey since the form has been loaded via parentEntityType and parentEntityID.
					// since the form may not know to add the primary key (e.g., if no other form fields has been changed) this has to be done here.
					if(this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data.length > 0){
						if(this.config.resourceConnected && !this.config.creationMode && !this.config.copyMode) this.fieldToModel('primaryKey', undefined, undefined, true);
					}
				}
			}
			else if(fieldData.type === 'keepNull'){
				// cleanup dirtyFields
				if(
					this.model.dirtyFields.data &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer] &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias] &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data &&
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data[fieldData.relationDataIndex]
				){
					this.model.dirtyFields.data[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data[fieldData.relationDataIndex] = null;

					// set own primaryKey in dirty fields for later usage if necessary.
					// e.g., this may happen if a componentContentForm has been loaded to handle a componentInstance without a primaryKey and only the componentInstances tags has been changed.
					// this would lead to a PATCH request whose url contains no primaryKey since the form has been loaded via parentEntityType and parentEntityID.
					// since the form may not know to add the primary key (e.g., if no other form fields has been changed) this has to be done here.
					if(this.config.resourceConnected && !this.config.creationMode && !this.config.copyMode) this.fieldToModel('primaryKey', undefined, undefined, true);
				}
			}
			else if(fieldData.type === 'create' || fieldData.type === 'update' || fieldData.type === 'delete'){
				if(!this.model.dirtyFields.data) this.model.dirtyFields.data = {};

				var dirtyData = this.model.dirtyFields.data;
				if(!dirtyData[fieldData.relationConfig.subFormAliasContainer]) 												dirtyData[fieldData.relationConfig.subFormAliasContainer] = {};
				if(!dirtyData[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias]) 		dirtyData[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias] = {};
				if(!dirtyData[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data) 	dirtyData[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data = [];

				var dirtyRelationData = dirtyData[fieldData.relationConfig.subFormAliasContainer][fieldData.relationConfig.subFormAlias].data;
				dirtyRelationData[fieldData.relationDataIndex] = fieldData.value;

				if(fieldData.type === 'delete'){
					dirtyRelationData[fieldData.relationDataIndex].type = 'delete';
				}

				// set own primaryKey in dirty fields for later usage if necessary.
				// e.g., this may happen if a componentContentForm has been loaded to handle a componentInstance without a primaryKey and only the componentInstances tags has been changed.
				// this would lead to a PATCH request whose url contains no primaryKey since the form has been loaded via parentEntityType and parentEntityID.
				// since the form may not know to add the primary key (e.g., if no other form fields has been changed) this has to be done here.
				if(this.config.resourceConnected && !this.config.creationMode && !this.config.copyMode) this.fieldToModel('primaryKey', undefined, undefined, true);
			}
			else {
				changeDone = false;
			}

			// call on-change-handler for extended forms.
			this.onChange(true, changeDone, fieldData);

			this.autoSubmit()
		},

		/**
		 * returns the value of the field identified by the fieldCode and the given resourceType.
		 * if a component (e.g., the tag-picker-button) wants to know the difference between the actual live value and the dirty value of its own field, this method comes in handy.
		 *
		 * @param fieldCode			string - fieldCode
		 * @param resourceType		string - optional - "" => newest value, "live" => value stored in resourceData, "dirty" => value stored in model.dirtyFields
		 * @return mixed
		 */
		getFieldValue: function(fieldCode, resourceType){
			var fieldProperties = this.getFieldProperties(fieldCode) || {};
			var dirtyValue, value;

			if(fieldProperties.hasFieldCodeDependency){
				if(utils.collectionSize(fieldProperties.fieldCodeDependencyList) > 0){
					console.error('unable to obtain dependency list field values');
					return;
				} else if (fieldProperties.relatedFieldCode && fieldProperties.writeSimpleParentJsonAttribute){
					var relatedFieldProperties = this.getFieldProperties(fieldProperties.relatedFieldCode);
					if(relatedFieldProperties.attributeKey && relatedFieldProperties.dataType === 'json') {
						if(relatedFieldProperties.dataIndex !== undefined){
							dirtyValue = (((((this.model.dirtyFields || {}).data || [])[relatedFieldProperties.dataIndex] || {}).attributes || {})[relatedFieldProperties.attributeKey] || {})[fieldProperties.fieldCodeAlias || fieldProperties.fieldCode]
							value = ((((this.resourceData.data || [])[relatedFieldProperties.dataIndex] || {}).attributes || {})[relatedFieldProperties.attributeKey] || {})[fieldProperties.fieldCodeAlias || fieldProperties.fieldCode]
						} else {
							dirtyValue = ((((this.model.dirtyFields || {}).data || {}).attributes || {})[relatedFieldProperties.attributeKey] || {})[fieldProperties.fieldCodeAlias || fieldProperties.fieldCode]
							value = (((this.resourceData.data || {}).attributes || {})[relatedFieldProperties.attributeKey] || {})[fieldProperties.fieldCodeAlias || fieldProperties.fieldCode]
						}
					} else {
						// TODO: implement complex relatedFieldCodes!
					}
				}
			}
			if(fieldProperties.attributeKey !== undefined) {
				if(fieldProperties.dataIndex !== undefined) {
					dirtyValue = ((((this.model.dirtyFields || {}).data || [])[fieldProperties.dataIndex] || {}).attributes || {})[fieldProperties.attributeKey]
					value = (((this.resourceData.data || [])[fieldProperties.dataIndex] || {}).attributes || {})[fieldProperties.attributeKey]
				} else {
					dirtyValue = (((this.model.dirtyFields || {}).data || {}).attributes || {})[fieldProperties.attributeKey]
					value = ((this.resourceData.data || {}).attributes || {})[fieldProperties.attributeKey]
				}
			} else {
				// TODO: implement complex cases!
			}

			if(resourceType === 'live') 	return value;
			if(resourceType === 'dirty') 	return dirtyValue;
			if(dirtyValue !== undefined)	return dirtyValue;
			return value;
		},

		/**
		 * this helper function is used to perform a given callback function for all direct subForms of this form.
		 * the first and only parameter given to the callback is the subForm component.
		 *
		 * @param callback      function
		 */
		forEachSubForm: function(callback){
			if(!utils.isFunction(callback)) return;

			this.find('base_form_form', subForm => {
				if(subForm.$.hasClass('subForm')){
					return callback(subForm);
				}
				else if(!subForm.hasClass('base_form_relationship')) {
					return 'breakRecursion';
				}
			});
		},


		///////////////////////////////////////////
		///// Handler Methods
		///////////////////////////////////////////

		/**
		 * this function is used to call the prepareForSubmit function on all subComponents if possible / necessary.
		 *
		 * @return Promise
		 */
		prepareChildrenForSubmit: function(){
			var preparationPromises = [];

			if(utils.isFunction(this.prepareForSubmit)){
				// this unshift is used to prepare the children before their parents
				preparationPromises.unshift(this.prepareForSubmit())
			}
			this.find(undefined, childComponent => {
				if(utils.isFunction(childComponent.prepareForSubmit)){
					// this unshift is used to prepare the children before their parents
					preparationPromises.unshift(childComponent.prepareForSubmit())
				}
			});

			return utils.promise.performAll(this, preparationPromises)
				.then(() => utils.promise.resolve())
		},

		/**
		 * this function may be overwritten by inheritance forms.
		 *
		 * @return Promise
		 */
		prepareForSubmit: function(){
			return utils.promise.resolve();
		},

		/**
		 * this function is used to set all default values if possible
		 *
		 * @params  dirties         object - dirties object given by this.getDirties()
		 * @params  presetValues    boolean - this flag can be used to set default values within the model in case of creation forms to get the right default values during the render process if necessary
		 */
		setDefaultValues: function(dirties, presetValues){

			if(this.config.creationMode){

				var self = this;
				var defaultValueFound, firstOptionKey;
				var formName = self.config.subFormAlias || self.config.defaultFormName;
				var templateAtomID;
				var defaultValue, testValue;
				var field, fieldCode, $field;
				var fieldType, poolKey, fieldComponent;

				// ensure that all used fields' default values are set within the dirtyFields if a default value exists.
				utils.forEach(this.model.fieldProperties, function(fieldProperties, fieldName){

					// NOTE: component content forms have multiple dataJSON and other data-fields. so the templateAtomID has to be taken into account during dirty field recognition.
					templateAtomID = -1;
					if(self.config.componentDataDependentFieldAssociation && fieldProperties.staticFields && fieldProperties.staticFields.templateAtomID){
						templateAtomID = fieldProperties.staticFields.templateAtomID;
					}

					// model field of type pickers found with a relation to a resource element and which has not been set previously by the user.
					defaultValueFound = false;
					if((fieldType = self.config.fieldTypes[fieldProperties.dataType])){

						if(fieldType.defaultSource === 'picker') poolKey = fieldProperties.dataType + '-data';
						else                                    poolKey = undefined;

						if(fieldProperties.attributeKey && (!dirties || !dirties[formName] || !dirties[formName][fieldProperties.attributeKey + (templateAtomID < 0 ? '~' : '-' + templateAtomID)]) && fieldProperties.modelFieldIndex && self.model.fields[fieldProperties.modelFieldIndex] && (!poolKey || self.model.fields[fieldProperties.modelFieldIndex][poolKey])){
							firstOptionKey = undefined;

							// look for default value
							if(fieldType.defaultSource === 'picker'){
								if((defaultValue = ((field = (self.model.fields[fieldProperties.modelFieldIndex] || {})).config || {}).defaultValue) !== undefined && !field.config.defaultValueField){
									defaultValueFound = true;
									self.fieldToModel(field.fieldCode, self.getDefaultValue(defaultValue), !!presetValues);
								} else {
									utils.forEach(field[poolKey].options || [], function(option, optionKey){
										if(firstOptionKey === undefined){
											firstOptionKey = optionKey;
										}
										if(field.config.defaultValue){
											testValue = option.value;
											if(field.config.defaultValueField){
												testValue = ((option.resource || {}).attributes || {})[field.config.defaultValueField];
											}
											if(testValue == field.config.defaultValue){
												defaultValueFound = true;
												self.fieldToModel(field.fieldCode, option.value);
												return false;
											}
										} else if(option.defaultSelected){
											defaultValueFound = true;
											self.fieldToModel(field.fieldCode, option.value);
											return false;
										}
									});

									// take first value if no defaultValue has been found
									if(!defaultValueFound && firstOptionKey !== undefined && fieldProperties.firstOptionSelectionGranted){
										defaultValueFound = true;
										self.fieldToModel(self.model.fields[fieldProperties.modelFieldIndex].fieldCode, self.model.fields[fieldProperties.modelFieldIndex][poolKey].options[firstOptionKey].value, !!presetValues);
									}
								}

							}
							else if(fieldType.defaultSource === 'config'){
								if((defaultValue = ((field = (self.model.fields[fieldProperties.modelFieldIndex] || {})).config || {}).defaultValue) !== undefined){
									defaultValueFound = true;
									self.fieldToModel(field.fieldCode, self.getDefaultValue(defaultValue), !!presetValues);
								}
							}
						}
					}

					// set default value by field-component function if possible
					if(
						!defaultValueFound &&
						(fieldCode = (field = self.model.fields[fieldProperties.modelFieldIndex] || {}).fieldCode) &&
						self.$ &&
						($field = self.$.find('[data-field-code="' + fieldCode + '"]')).length > 0 &&
						(fieldComponent = getComponent($field, true)) &&
						utils.isFunction(fieldComponent.setDefaultValue)
					){
						fieldComponent.setDefaultValue();
					}
				});
			}
		},

		/**
		 * this function is used to estimate generic default values.
		 *
		 * @param 	value		String - value default definition
		 * @returns 			mixed - real value
		 */
		getDefaultValue: function(value){
			if(String(value).match(/\(\)$/)){
				switch(value){
					case 'day()': return moment().format('DD');
					case 'month()': return moment().format('MM');
					case 'year()': return moment().format('YYYY');
					case 'date()': return moment().format('YYYY-MM-DD');
					case 'fullDate()': return moment().format();
				}
			}

			return value;
		},

		/**
		 * will be called right after sanitizeForm() is done
		 */
		onSanitizeFormDone(){
			// NOTE: overwrite if necessary
		},

		/**
		 * this function will be called before a submit call will be performed.
		 *
		 * @param   isDirty     		boolean - has the actual form or one of its' sub-forms been marked as dirty
		 * @param   dirties     		array - list of all elements which are dirty and can be changed by the user
		 * @param   validationResult	object - validationResult
		 * @param   [isMainForm=true]	boolean - is this the mainForm or some subForm calling?
		 */
		onBeforeSubmit: function(isDirty, dirties, validationResult, isMainForm = true){
			if(isDirty){
				if(this.config.creationMode){
					this.setDefaultValues(dirties);
				}

				// prevent dirties which should not be transmitted
				var fieldCode;
				var fieldProperties;
				for(fieldCode in ((this.model.dirtyFields || {}).data || {}).attributes || {}){
					fieldProperties = this.getFieldProperties(fieldCode) || {};
					if(fieldProperties.preventTransfer){
						delete this.model.dirtyFields.data.attributes[fieldCode];
					}
				}

				// add simpleJsonParentAttributes if necessary
				var jsonParentAttributes = {};
				for(fieldCode in this.model.namedFields){
					fieldProperties = this.getFieldProperties(fieldCode) || {};
					if(fieldProperties.relatedFieldCode && fieldProperties.writeSimpleParentJsonAttribute){
						jsonParentAttributes[fieldProperties.relatedFieldCode] = true;
					}
				}

				// validate this component
				var validatorAttributes = [];
				if(this.model.dirtyFields && this.model.dirtyFields.data && this.model.dirtyFields.data.attributes){
					for(fieldCode in jsonParentAttributes){
						if(this.model.dirtyFields.data.attributes[fieldCode]){
							validatorAttributes.push(this.model.dirtyFields.data.attributes[fieldCode]);
						}
					}
					validatorAttributes.push(this.model.dirtyFields.data.attributes);
				}
				if(this.resourceData.data && this.resourceData.data.attributes) {
					for(fieldCode in jsonParentAttributes){
						if(this.resourceData.data.attributes[fieldCode]){
							validatorAttributes.push(this.resourceData.data.attributes[fieldCode]);
						}
					}
					validatorAttributes.push(this.resourceData.data.attributes);
				}

				// prepare fieldCodes which should not be validated.
				const preventValidationFieldCodes = {}
				utils.forEach(this.model.fieldProperties || {}, (fieldProperties, fieldCode) => {
					if(fieldProperties.preventValidation){
						preventValidationFieldCodes[fieldCode] = true
					}
				})

				validationResult[this.validatorRuleSetID] = this.validate(validatorAttributes, undefined, this.model.namedFields, preventValidationFieldCodes);
				var firstInvalidValidationResult = !validationResult.invalid && validationResult[this.validatorRuleSetID].invalid;
				if(this.handleValidationResult(validationResult[this.validatorRuleSetID], firstInvalidValidationResult) === false){
					validationResult.invalid |= validationResult[this.validatorRuleSetID].invalid;
				}

				// check sub-forms also
				if(isMainForm){
					this.forEachSubForm(subFormComponent => {
						subFormComponent.onBeforeSubmit(isDirty, dirties, validationResult, false);
					});
				}
			}
		},

		/**
		 * this function will be called after the response of a submit request has returned.
		 *
		 * @param   response        object - server response
		 * @param   insertionDone   boolean - has an insert been performed or not
		 */
		onSubmit: function(response, insertionDone){
			// NOTE: this function can be overwritten by inherited form components if needed
		},

		/**
		 * this function will be called after the form has not been sent due to missing changes.
		 */
		onSubmitNothing(){
			// NOTE: this function can be overwritten by inherited form components if needed
		},

		/**
		 * this function will be called after the click on a cancel button and before the afterCancel handler.
		 */
		onCancel: function(response){
			// NOTE: this function can be overwritten by inherited form components if needed
		},

		/**
		 * this function will be called after the form values has been changed.
		 *
		 * @param isRelationChange 		boolean - was the change related to a relation or not
		 * @param changeDone 			boolean - has a change been done
		 * @param fieldData 			object - fieldData used to define what to do
		 */
		onChange: function(isRelationChange, changeDone, fieldData){
			// NOTE: this function can be overwritten by inherited form components if needed
		},

		/**
		 * this function will be executed directly before the render process will be started.
		 */
		onBeforeRender: function(storage){
			// NOTE: 	clients may render such a form without resources which could be sanitized.
			//			in these cases the parentForm has to be identified here.
			// estimate parentForm in case of this being a subForm
			if(!!this.config.subFormAlias && !this.parentForm && storage.isClient){
				this.parentComponents('base_form_form', parentForm => {
					this.parentForm = parentForm
					this.config.isRelationshipChild = this.parentForm.hasClass('base_form_relationship')
					this.config.isProtocolActionForm = this.parentForm.config.isProtocolActionForm
					return false;
				});
			}

			this.sanitizeDirtyFields();
		},

		showFieldDescription: function(info){
			if(this.parentForm){
				this.parentForm.showFieldDescription(info);
			} else {
				this.triggerFind('showFieldDescription', { info });
			}
		},

		hideFieldDescription: function(info){
			if(this.parentForm){
				this.parentForm.hideFieldDescription(info);
			} else {
				this.triggerFind('hideFieldDescription');
			}
		},

		/**
		 * this function will be called in case this component is being refreshed.
		 *
		 * @param options		object - these are the attach-trigger-options which will be used after this refresh for the attach trigger.
		 */
		onBeforeRefresh: function(options){
			if(this.config.resetDirtyFieldsBeforeRefresh){
				this.resetDirties()
			}
		},

		///////////////////////////////////////////
		///// COMMON HELPER Methods
		///////////////////////////////////////////

		/**
		 * this function merges the resourceData and dirtyModelFields but replaces all attributes (and children's attributes)
		 * to prevent merge errors on complex dataJSON fields (e.g., images, files, config, actions, ...).
		 *
		 * @param refTarget				object - target data object
		 * @param resourceData			object - resourceData object
		 * @param dirtyModelFields		object - dirtyModelFields object
		 * @param resourceCopyDone		boolean - internal boolean flag used within recursion
		 * 								NOTE: never ever set this parameter from outside this function!
		 */
		replaceResourceAttributes: function(refTarget, resourceData, dirtyModelFields, resourceCopyDone){
			if(!refTarget) return;

			if((resourceData || {}).data && !(dirtyModelFields || {}).data){
				refTarget.data = utils.simpleCopy(resourceData.data);
			} else if(!(resourceData || {}).data && (dirtyModelFields || {}).data) {
				refTarget.data = utils.simpleCopy(dirtyModelFields.data);
			} else {
				var singleDataMode = true;
				if(Array.isArray(resourceData.data)) singleDataMode = false;

				var targetDataList, resourceDataList, dirtyDataList;
				if(singleDataMode){
					if(!refTarget.data) refTarget.data = {};
					targetDataList 		= [refTarget.data];
					resourceDataList 	= [resourceData.data];
					dirtyDataList 		= [dirtyModelFields.data];
				} else {
					if(!refTarget.data) refTarget.data = [];
					targetDataList 		= refTarget.data;
					resourceDataList 	= resourceData.data;
					dirtyDataList 		= dirtyModelFields.data;
				}

				// collect keys
				const keys = []
				let d, k, c
				for(d in resourceDataList){
					keys[d] = true
				}
				for(d in dirtyDataList){
					keys[d] = true
				}
				for(d in keys){
					if(resourceDataList[d] && dirtyDataList[d] === undefined){
						if(!resourceCopyDone){
							targetDataList[d] = utils.simpleCopy(resourceDataList[d]);
						}
					} else if(resourceDataList[d] === undefined && dirtyDataList[d]){
						targetDataList[d] = utils.simpleCopy(dirtyDataList[d]);
					} else {
						if(!resourceCopyDone){
							targetDataList[d] = utils.simpleCopy(resourceDataList[d]);
						}

						for(k in dirtyDataList[d]){
							if(k === 'attributes'){
								targetDataList[d][k] = utils.replace(targetDataList[d][k] || {}, dirtyDataList[d][k]);
							} else if(k === 'children' || k === 'relationships') {
								if(!targetDataList[d][k]) targetDataList[d][k] = {};
								if(!resourceDataList[d][k]) resourceDataList[d][k] = {};
								for(c in dirtyDataList[d][k]){
									this.replaceResourceAttributes(targetDataList[d][k][c], resourceDataList[d][k][c], dirtyDataList[d][k][c], true);
								}
							} else {
								targetDataList[d][k] = utils.simpleCopy(dirtyDataList[d][k]);
							}
						}
					}
				}

				if(singleDataMode){
					refTarget.data = targetDataList[0];
				}
			}
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			// NOTE: OVERWRITE IF NECESSARY
		},

		/**
		 * return owner which should be used for permissions within this form.
		 * e.g., file upload
		 *
		 * @param storage		actual storage
		 * @returns mixed 		userID or null
		 */
		getOwner(storage = false){
			// NOTE: OVERWRITE IF NECESSARY
			return utils.permissions.getOwner(storage || this.getStorage())
		}
	},

	hooks: {
		attach: function($element, options){
			// prepare default actions
			this.prepareDefaultActions();

			if(!options.refresh) {
				this.config.isStaticForm = (this.config.creationMode && this.isParentActionStatic && !this.parentForm);
			}

			if(utils.isFunction(this.onAttachDone)){
				this.onAttachDone(options);
			}

			// check if browser has filled in some data without triggering any change events
			if(!options.refresh && this.config.checkForBrowserFills){
				var self = this;
				utils.forEach(this.model.fields, function(field, fieldIndex){
					var $inputField = $element.find('[data-field-code="' + field.fieldCode + '"]');
					if($inputField.length > 0){
						var target = $inputField[0];
						var defaultValue = target.defaultValue;
						var value = utils.dom.getHtmlFieldValue($inputField.data('fieldType'), target);
						if(!target.disabled && defaultValue != value){
							self.fieldToModel(field.fieldCode, value);
						}
						if(fieldIndex == 0){
							$inputField.focus();
						}
					}
				});
			}

			// check if autoSubmit is necessary
			if(!options.refresh && this.config.autoSubmitOnAttach){
				this.submit();
				this.config.autoSubmitOnAttach = false;
			}
		},

		async onChildChanged($element, options){
			if(options.isRelation){
				await this.relationFieldToModel(options);
			}
			else {
				await this.fieldToModel(options.fieldCode, options.value)

				if(!this.config.subFormAlias || !this.parentForm){
					await this.trigger('onChange', {
						fieldCode:  options.fieldCode,
						value:      options.value
					});
				}
				else {
					await this.triggerClosest('onChange', {
						fieldCode:  options.fieldCode,
						value:      options.value
					}, 'base_form_form');
				}
			}
		},

		async onDecision($element, options){
			// should this decision be translated into a field change, or ...
			if(options && options.decisionOptions){
				// perform a default field change, or ...
				if(!options.decisionOptions.type && options.decisionOptions.fieldCode){
					const setAllData = (Array.isArray(options.data) && options.data.length > 0)
					const setSingleDataElement = (options.decisionOptions.dataAttribute && options.data[options.decisionOptions.dataAttribute])
					if(options.data && (setAllData || setSingleDataElement)){
						let value
						if(setAllData)                  value = options.data;
						else if(setSingleDataElement)   value = options.data[options.decisionOptions.dataAttribute];

						await this.trigger('onChildChanged', {
							fieldCode:  options.decisionOptions.fieldCode,
							value:      value
						})
					}

					if(utils.isFunction(this.onDecision)){
						await this.onDecision(options)
					}
				}
				// ... should the trigger target component decide what to do by itself.
				else {
					// in case of forms the onDecision method should be called
					if(!options.decisionOptions.decisionComponentClass || this.hasClass(options.decisionOptions.decisionComponentClass)){
						if(utils.isFunction(this.onDecision)){
							await this.onDecision(options)
						}
					}
					// use onDecision trigger otherwise
					else {
						await this.triggerClosest('onDecision', options, options.decisionOptions.decisionComponentClass)
					}
				}
			}
			// ... should the trigger be handed over to the next onDecision handler.
			else {
				await this.triggerClosest('onDecision', options)
			}
		}
	},

	handlers: [
		{
			name: 'heartbeat.resourceChanged',
			handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
				this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
			}
		},
		{
			name: 'heartbeat.reconnect',
			handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
				this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
			}
		},
	],
};
